import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import 'react-tooltip/dist/react-tooltip.css';
import Geoloacateicon from '../assests/Geoloacateicon.svg';
import globalIcon from '../assests/globalIcon.svg';
import Zoominicon from '../assests/MapTools/Zoominicon.svg';
import Zoomouticon from '../assests/MapTools/Zoomouticon.svg';
import locationicon, { ReactComponent as Mapmarker } from '../assests/Mapmark-01.svg';
import HomeStyles from '../styles/Home.module.css';
import '../styles/globalStyles/mapbox.css';
import {Map as MapGL, Marker} from 'react-map-gl'; // for geocoding API
import "mapbox-gl/dist/mapbox-gl.css";
import BusinessLogic from './BusinessLogic';
import {findLayersWithin2NM, preloadGeoJSONCache} from '../utils/layerProximityFilter';
import 'react-datetime/css/react-datetime.css';
import { formatInTimeZone } from 'date-fns-tz';
import { enUS } from 'date-fns/locale/en-US'
import PersonalInfo from './personalinfor';
import { format, parse } from 'date-fns';
import { useLocation, useNavigate } from "react-router-dom";
import * as turf from '@turf/turf';
import { useAuth0 } from '@auth0/auth0-react';
import Sliders from './detailbar/Sliders';
import LocationDetails from './detailbar/LocationDetails';
import DateTimePicker from './detailbar/DateTimePicker';
import Advisories from './detailbar/Advisories';
import DetailBarButtons from './detailbar/DetailBarButtons';
//auth
import { useAuth } from "../context/authContext";
import {
    preCheckOperation,
    preInvalidCheckOperation,
    submitOperation,
    isEmailVerifiedOperation
} from "../network/apis/operation.api";
import { useProfile } from '../context/userContext';
import { useOrganization } from '../context/OrganizationContext';
import PopupAlert from '../components/PopupAlert';

function Home({ selectedPurpose_dummy, selectedLayers, onSelectLayers, sendDataToParent }) {
    const { profile, loading, error } = useProfile();
    const { isOrganizationUser, isInOrganizationMode, loading: orgLoading, currentOrganization } = useOrganization();
    const navigate = useNavigate();
    const location = useLocation();
    const [errorDetails, setErrorDetails] = useState({ error: null, description: null });
    const [open, setOpen] = useState(false);

    const { loginWithRedirect, logout } = useAuth0();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const error = queryParams.get("error");
        const errorDescription = queryParams.get("error_description");

        if (error) {
            setErrorDetails({
                error,
                description: decodeURIComponent(errorDescription)
            });
            setOpen(true);
        } else {

            setOpen(false);
        }
    }, [location.search]);

    // Post-login routing: Redirect users in organization mode to dashboard
    useEffect(() => {
        // Wait for both profile and organization context to load
        if (loading || orgLoading) return;

        // Skip redirect if user is on /operations/create (organization users creating LAANC operations)
        if (location.pathname === '/operations/create') return;

        // Redirect only if user is actively in organization mode
        if (isInOrganizationMode && profile) {
            navigate('/dashboard', {replace: true});
        }
    }, [isInOrganizationMode, loading, orgLoading, profile, navigate, location.pathname]);

    const handleClose = async () => {
        try {
            logout({
                logoutParams: {
                    returnTo: window.location.origin,
                },
            });

            //console.log('Logout initiated successfully, redirecting to:', window.location.origin);
        } catch (error) {
            //console.error('Error during logout:', error);
        }
    };

    const mapArray = process.env.REACT_APP_MAP_STYLES
        ? JSON.parse(process.env.REACT_APP_MAP_STYLES)
        : [];

    let geocoder = null;
    const [mapLayers, setMapLayers] = useState([]);
    const [newPlace, setNewPlace] = useState(null);
    const [viewPort, setViewPort] = useState({
        longitude: -98.5795,
        latitude: 39.8283,
        zoom: 4.5,
    });
    const [currentMapStyle, setCurrentMapStyle] = useState(mapArray[0]);
    const [mapRef, setMapRef] = useState(null);
    const [clickCount, setClickCount] = useState(1);
    const [markerVisible, setMarkerVisible] = useState(false);
    const [mapLoadOnce, setMapLoadOnce] = useState(false);
    const [mapTilesLoaded, setMapTilesLoaded] = useState(false);
    const [styleLoaded, setStyleLoaded] = useState(false);
    const [detailbarContent, setDetailbarContent] = useState({
        placeName: '',
        layers: [],
        properties: [],
        loc_currentTime: ''
    });
    const [detailbarVisible, setDetailbarVisible] = useState(false);
    const [detailbarButtonVisible, setDetailbarButtonVisible] = useState(true);
    const [maxAltitude, setMaxAltitude] = useState(400);
    const [radius, setRadius] = useState(1000); // Default radius in ft
    const [circleCenter, setCircleCenter] = useState([viewPort.longitude, viewPort.latitude]);
    const [zoomLevel, setZoomLevel] = useState(15); // Default zoom level for flying
    const [altitude, setAltitude] = useState(0); // State for the altitude slider
    const [circleGeoJSON, setCircleGeoJSON] = useState(null); // State for circle GeoJSON
    const [geometryType, setGeometryType] = useState('circle'); // 'circle' or 'polygon'
    const [polygonPoints, setPolygonPoints] = useState([]); // Array of [lng, lat] points for polygon drawing
    const [isDrawingPolygon, setIsDrawingPolygon] = useState(false); // Flag to indicate polygon drawing mode
    const [polygonError, setPolygonError] = useState(null); // Validation error shown inside detail bar
    const [selectedLocationDateTime, setSelectedLocationDateTime] = useState(''); // State for selected date time
    const [addressDetails, setAddressDetails] = useState(''); // State for address details
    const [overlappingLayersFeatures, setOverlappingLayers] = useState([]); // for overlapping layers that are in the selected area
    const [selectedDateMui, setSelectedDateMui] = useState(null);
    const [selectedTimeMui, setSelectedTimeMui] = useState(null);
    const [selectedDate, setSelectedDate] = useState(''); // State for selected date
    const [currentLocaDate, setCurrentLocaDate] = useState(''); // State for current local date
    const [selectedTime, setSelectedTime] = useState('');
    const [duration, setDuration] = useState(15); // State for duration
    const [selectedTimeZone, setSelectedTimeZone] = useState('America/New_York');
    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [view, setView] = useState('detailbar');
    const [maxDate, setMaxDate] = useState(new Date());
    const [suntime, setSuntime] = useState({});
    const [airportData, setAirportData] = useState([]); // store airport data
    const [airportMarkers, setAirportMarkers] = useState([]); // track airport POI markers
    const [nearbyAirportsData, setNearbyAirportsData] = useState([]); // track nearby airports for Advisories
    const [nearbyAirspaces, setNearbyAirspaces] = useState([]); // track nearby class airspaces
    const [alert, setAlert] = useState({
        visible: false,
        content: ''
    });
    const [preCheck, setPreCheck] = useState(true);// flag for overlapping overations
    const [preInvalidCheck, setPreInvalidCheck] = useState(true);
    const [isUserEmailVerified, setIsUserEmailVerified] = useState(false);
    const [allLayers, setAllLayers] = useState([]);
    const [slideEvent, setSlideEvent] = useState(false);
    const slideEventRef = useRef(slideEvent);  // ES6 const and hooks
    const detailbarRef = useRef(null);  // Ref for detailbar accessibility
    const templateGeometryRef = useRef(null); // Store template geometry temporarily
    const [loadDetailBarLogic, setLoadDetailBarLogic] = useState(false); // double click event
    const [loadParamLogic, setLoadParamLogic] = useState(false); // parameter change event

    const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
    const [captchaValue, setCaptchaValue] = useState("");
    const [selectedPurpose, setSelectedPurpose] = useState("44809")

    // Optimization Item #3: API response caching to reduce network requests by 50-70%
    // Each location gets its own cache entry based on coordinates
    const geocodeCache = useRef(new Map()); // Key: "lng,lat" -> cached response
    const timezoneCache = useRef(new Map()); // Key: "lat,lng" -> cached response
    const CACHE_MAX_SIZE = 100; // Prevent memory bloat

    const [showTip, setShowTip] = useState(false);

    const { authenticated, token } = useAuth();
    //console.log('token',token)
    //console.log('authenticated',authenticated)

    // recaptcha
    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    useEffect(() => {
        // Show the tip when the component is first loaded
        setShowTip(true);
    }, []);

    const closeTip = () => {
        setShowTip(false);
    };

    useEffect(() => {
        if (profile) {
            setSelectedPurpose(profile.faaIDType);
        }
    }, [profile]);

    // Handle geometry type changes
    useEffect(() => {

        if (geometryType === 'circle') {
            // Clear polygon data when switching to circle

            // Inline polygon clearing (don't call handleClearPolygon to avoid stale closure)
            setPolygonPoints([]);
            setIsDrawingPolygon(false);

            // Remove polygon drawing layers
            if (mapRef) {
                if (mapRef.getLayer('polygonPoints')) {
                    mapRef.removeLayer('polygonPoints');
                }
                if (mapRef.getLayer('polygonLines')) {
                    mapRef.removeLayer('polygonLines');
                }
                if (mapRef.getSource('polygonDrawingSource')) {
                    mapRef.removeSource('polygonDrawingSource');
                }
                if (mapRef.getSource('polygonLinesSource')) {
                    mapRef.removeSource('polygonLinesSource');
                }

                // Remove completed polygon if exists
                if (mapRef.getLayer('circleOutline')) {
                    mapRef.removeLayer('circleOutline');
                }
                if (mapRef.getLayer('circleLayer')) {
                    mapRef.removeLayer('circleLayer');
                }
                if (mapRef.getSource('circleSource')) {
                    mapRef.removeSource('circleSource');
                }
            }

            // If we have a location (newPlace), create a circle there
            if (newPlace && mapRef) {
                setCircleGeoJSON(null); // Clear old geometry first
                setLoadParamLogic(true); // Trigger circle creation
            } else {
                setCircleGeoJSON(null);
            }
        } else if (geometryType === 'polygon') {
            // Clear circle data when switching to polygon

            // Remove circle layers and source
            if (mapRef) {
                if (mapRef.getLayer('circleOutline')) {
                    mapRef.removeLayer('circleOutline');
                }
                if (mapRef.getLayer('circleLayer')) {
                    mapRef.removeLayer('circleLayer');
                }
                if (mapRef.getSource('circleSource')) {
                    mapRef.removeSource('circleSource');
                }
            }

            // Clear circle state
            setCircleGeoJSON(null);

            // Open detail bar so user can see polygon drawing controls
            setDetailbarVisible(true);
            setView('detailbar');
        }
    }, [geometryType, mapRef]);

    // Load template data if coming from templates page
    useEffect(() => {
        // Optimization Item #16: AbortController to cancel in-flight requests on unmount
        const abortController = new AbortController();

        if (location.state?.templateGeometry && location.state?.templateData && mapRef) {
            const {templateGeometry, templateData} = location.state;


            // Reset state for clean template load
            setLoadDetailBarLogic(false);
            setAlert({visible: false, content: ''});
            setPreCheck(true);
            setDetailbarButtonVisible(true);
            setAltitude(0);
            setMaxAltitude(400);

            // Detect if this is a polygon or circle based on the geometry
            // Circles have many points (150), polygons have fewer custom points
            const geomCoords = templateGeometry?.geometry?.coordinates?.[0] ||
                templateGeometry?.features?.[0]?.geometry?.coordinates?.[0] ||
                templateGeometry?.coordinates?.[0];

            const isPolygon = geomCoords && geomCoords.length < 100; // Circles have 150 points, polygons have < 100


            // Set geometry type based on detection
            setGeometryType(isPolygon ? 'polygon' : 'circle');

            // Store in ref for immediate access
            templateGeometryRef.current = templateGeometry;

            // Load geometry to map
            setCircleGeoJSON(templateGeometry);

            // Calculate center from geometry coordinates
            let center = null;

            // Handle both Feature and FeatureCollection
            let coordinates = null;
            if (templateGeometry?.type === 'Feature') {
                coordinates = templateGeometry?.geometry?.coordinates?.[0];
            } else if (templateGeometry?.type === 'FeatureCollection') {
                coordinates = templateGeometry?.features?.[0]?.geometry?.coordinates?.[0];
            } else if (templateGeometry?.coordinates) {
                // Direct geometry object
                coordinates = templateGeometry?.coordinates?.[0];
            }

            if (coordinates && coordinates.length > 0) {
                const lngs = coordinates.map(coord => coord[0]);
                const lats = coordinates.map(coord => coord[1]);
                const centerLng = (Math.min(...lngs) + Math.max(...lngs)) / 2;
                const centerLat = (Math.min(...lats) + Math.max(...lats)) / 2;
                center = [centerLng, centerLat];
                setCircleCenter(center);
                setNewPlace({lat: centerLat, long: centerLng});

                // Fetch location details (same as when user clicks map)
                const initializeLocationData = async () => {
                    try {
                        // Optimization Item #16: Check if aborted before async operations
                        if (abortController.signal.aborted) return;

                        // Fetch reverse geocode for address (Optimization Item #3: cached)
                        const geocodeData = await fetchGeocodeCached(centerLng, centerLat);

                        if (abortController.signal.aborted) return;
                        const placeName = geocodeData.features[0]?.place_name
                            ? `${geocodeData.features[0]?.place_name}`
                            : `Latitude: ${centerLat}, Longitude: ${centerLng}`;
                        setAddressDetails(placeName);

                        if (abortController.signal.aborted) return;
                        // Fetch timezone and current date/time (Optimization Item #3: cached)
                        const timezoneData = await fetchTimezoneCached(centerLat, centerLng);
                        setSelectedTimeZone(timezoneData.timeZoneId);
                        const loc_currentTime = getISOTimeInTimeZone(timezoneData.timeZoneId);

                        // Convert timezone date time to formatted string
                        const formatString = "EEEE, MMMM d, yyyy 'at' HH:mm zzz";
                        const formatted_loc_currentTime = formatInTimeZone(new Date(loc_currentTime), timezoneData.timeZoneId, formatString, { locale: enUS });
                        setSelectedLocationDateTime(formatted_loc_currentTime);

                        // Extract date and time
                        const iso_pattern = loc_currentTime.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}):/);
                        const calendar_date = iso_pattern[1];
                        const calendar_time = iso_pattern[2];

                        setSelectedDate(calendar_date);
                        setCurrentLocaDate(calendar_date);
                        setSelectedTime(calendar_time);
                        setSelectedTimeMui(parse(convertToAMPM(calendar_time), 'h:mm a', new Date()));
                        setSelectedDateMui(new Date(calendar_date));

                        // Set max date to 90 days from now
                        const futureDate = new Date();
                        futureDate.setDate((new Date()).getDate() + 90);
                        setMaxDate(futureDate);

                        // Now that all location data is ready, trigger advisories fetch
                        setTimeout(() => {
                            setLoadParamLogic(true);
                        }, 500); // Small delay to ensure state is updated
                    } catch (error) {
                    }
                };

                initializeLocationData();
            } else {
            }

            // Wait for map to be ready before adding sources
            const addTemplateGeometry = () => {

                // Wait for both map and style to be loaded
                if (!mapRef.loaded() || !mapRef.isStyleLoaded()) {
                    // Use idle event which fires when map is fully loaded and ready
                    mapRef.once('idle', () => {
                        addTemplateGeometry();
                    });
                    return;
                }


                try {
                    // Clear existing circleSource and layers if they exist

                    // Remove outline layer if it exists
                    if (mapRef.getLayer('circleOutline')) {
                        mapRef.removeLayer('circleOutline');
                    }

                    // Remove fill layer if it exists
                    if (mapRef.getLayer('circleLayer')) {
                        mapRef.removeLayer('circleLayer');
                    }

                    // Remove source if it exists
                    if (mapRef.getSource('circleSource')) {
                        mapRef.removeSource('circleSource');
                    }

                    mapRef.addSource('circleSource', {
                        type: 'geojson',
                        data: templateGeometry
                    });

                    mapRef.addLayer({
                        'id': 'circleLayer',
                        'type': 'fill',
                        'source': 'circleSource',
                        'paint': {
                            'fill-color': '#088',
                            'fill-opacity': 0.3
                        }
                    });

                    // Add outline for better visibility (works for any polygon type)
                    mapRef.addLayer({
                        'id': 'circleOutline',
                        'type': 'line',
                        'source': 'circleSource',
                        'paint': {
                            'line-color': '#088',
                            'line-width': 2
                        }
                    });

                    // Fly to the template location with appropriate zoom
                    if (center) {
                        mapRef.flyTo({
                            center: center,
                            zoom: 15,
                            essential: true,
                            duration: 1500
                        });
                    }
                } catch (error) {
                }
            };

            addTemplateGeometry();

            // Populate form fields from template
            // Note: Operation type is NOT loaded from template - it uses the user's profile default (profile.faaIDType)
            // Note: Timezone, date, time, and address are fetched from APIs based on location

            if (templateData.maxAltitude !== undefined && templateData.maxAltitude !== null) {
                setMaxAltitude(templateData.maxAltitude);
            }
            if (templateData.radius !== undefined && templateData.radius !== null) {
                setRadius(templateData.radius);
            }
            if (templateData.duration !== undefined) {
                setDuration(templateData.duration);
            }

            // Show detail bar since we have template data loaded
            setDetailbarVisible(true);
            setView('detailbar');

            // Note: loadParamLogic is triggered after location data fetch completes (see above)

            // Clear the location state to prevent reloading on refresh
            navigate(location.pathname, {replace: true, state: {}});
        }

        // Handle redirection from Calendar to create event
        if (location.state?.isCreatingFromCalendar && location.state?.selectedDateTime) {
            const { selectedDateTime } = location.state;

            // Parse YYYY-MM-DD HH:mm or ISO format
            const [datePart, timePart] = selectedDateTime.split(' ');

            if (datePart && timePart) {
                const newDate = new Date(datePart);
                const [h, m] = timePart.split(':').map(Number);
                const newTime = new Date();
                newTime.setHours(h, m, 0, 0);

                setSelectedDateMui(newDate);
                setSelectedTimeMui(newTime);
                setSelectedDate(datePart);
                setSelectedTime(timePart);

                // Show guidance alert
                setAlert({
                    visible: true,
                    content: 'Please select a location on the map to complete your mission log creation.'
                });

                // Ensure detail bar is visible to show pre-filled data
                setDetailbarVisible(true);
                setView('detailbar');
            }

            // Clear state to avoid re-triggering
            navigate(location.pathname, { replace: true, state: {} });
        }

        // Optimization Item #16: Cleanup function to abort in-flight requests
        return () => {
            abortController.abort();
        };
    }, [location.state, mapRef]);

    useEffect(() => {
        setRefreshReCaptcha(true);
        window.Intercom('shutdown');// disable intercom chat
    }, []);

    useEffect(() => {
        if (selectedDateMui) {
            setSelectedDate(format(selectedDateMui, 'yyyy-MM-dd'));
        } else {
            setSelectedDate('');
        }
    }, [selectedDateMui]);

    useEffect(() => {
        if (selectedTimeMui) {
            setSelectedTime(format(selectedTimeMui, 'HH:mm')); // convertTo24Hour(selectedTimeMui)
        } else {
            setSelectedTime('');
        }
    }, [selectedTimeMui]);

    // Keyboard accessibility: Close detailbar on Escape key
    useEffect(() => {
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape' && detailbarVisible) {
                setDetailbarVisible(false);
                setView('detailbar');
            }
        };

        if (detailbarVisible) {
            document.addEventListener('keydown', handleEscapeKey);
        }

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [detailbarVisible]);

    // Focus management: Focus detailbar when it opens
    useEffect(() => {
        if (detailbarVisible && detailbarRef.current) {
            // Focus the detailbar container when it opens
            detailbarRef.current.focus();
        }
    }, [detailbarVisible]);

    // Optimization Item #2: Wrap event handlers in useCallback to reduce child re-renders
    const activateZoomin = useCallback(() => {
        mapRef.zoomIn();
        //console.log(mapRef.getZoom());
    }, [mapRef]);

    const activateZoomout = useCallback(() => {
        mapRef.zoomOut();
        //console.log(mapRef.getZoom());
    }, [mapRef]);

    const activateGlobal = () => {
        setClickCount((previousCount) => (previousCount + 1) % mapArray.length);
        setCurrentMapStyle(mapArray[(clickCount + 1) % mapArray.length]);
    };


    const createGeoJSONCircle = (center, radiusInKm, points) => {
        const coords = {
            latitude: center.lat,
            longitude: center.long
        };

        // TODO: change to ft calculations
        const km = radiusInKm;

        const ret = [];
        const distanceX = km / (111.32 * Math.cos(coords.latitude * Math.PI / 180));
        const distanceY = km / 110.574;

        for (let i = 0; i < points; i++) {
            const theta = (i / points) * (2 * Math.PI);
            const x = distanceX * Math.cos(theta);
            const y = distanceY * Math.sin(theta);

            ret.push([coords.longitude + x, coords.latitude + y]);
        }
        ret.push(ret[0]);


        //circleGeoJSON coordinates
        const geoJSON = {
            type: 'Feature',
            geometry: {
                type: 'Polygon',
                coordinates: [ret]
            }
        };

        // Update state with the new GeoJSON
        //setCircleGeoJSON(geoJSON);

        return geoJSON;
    };

    const fetchTimezone = async (latitude, longitude) => {

        //TODO: should get the planned time
        const epoch_time = Date.now() / 1000;

        //console.log(latitude + " " + longitude);

        const response = await fetch(`https://maps.googleapis.com/maps/api/timezone/json?location=${latitude}%2C${longitude}&timestamp=${epoch_time}&key=AIzaSyCAEZORYPchr39u-282iURsVw1iyMCCqnc`);
        if (response.ok) {
            const data = await response.json();
            //console.log("timezone data");
            return data;
        } else {
            throw new Error('Unable to fetch timezone data');
        }
    };

    // Optimization Item #3: Cached version of fetchTimezone
    const fetchTimezoneCached = useCallback(async (latitude, longitude) => {
        // Round to 4 decimal places (~11m precision) to create cache key
        const cacheKey = `${latitude.toFixed(4)},${longitude.toFixed(4)}`;

        // Check cache first
        if (timezoneCache.current.has(cacheKey)) {
            return timezoneCache.current.get(cacheKey);
        }

        // Fetch from API
        const data = await fetchTimezone(latitude, longitude);

        // Store in cache with LRU eviction
        if (timezoneCache.current.size >= CACHE_MAX_SIZE) {
            // Remove oldest entry (first key)
            const firstKey = timezoneCache.current.keys().next().value;
            timezoneCache.current.delete(firstKey);
        }
        timezoneCache.current.set(cacheKey, data);

        return data;
    }, []);

    // Optimization Item #3: Cached geocoding function
    const fetchGeocodeCached = useCallback(async (longitude, latitude) => {
        // Round to 5 decimal places (~1.1m precision) for cache key
        const cacheKey = `${longitude.toFixed(5)},${latitude.toFixed(5)}`;

        // Check cache first
        if (geocodeCache.current.has(cacheKey)) {
            return geocodeCache.current.get(cacheKey);
        }

        // Fetch from API
        const geocodeResponse = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude}%2C${latitude}.json?access_token=pk.eyJ1IjoidGhpbGFua2FkYW1pdGgiLCJhIjoiYjBUcG1DWSJ9.qk0Lif3yooEtjwaC5x8cFg`);
        const data = await geocodeResponse.json();

        // Store in cache with LRU eviction
        if (geocodeCache.current.size >= CACHE_MAX_SIZE) {
            const firstKey = geocodeCache.current.keys().next().value;
            geocodeCache.current.delete(firstKey);
        }
        geocodeCache.current.set(cacheKey, data);

        return data;
    }, []);

    const getISOTimeInTimeZone = (timeZone) => {
        const date = new Date();

        // Convert the date to the specified time zone using options
        const options = {
            timeZone: timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            fractionalSecondDigits: 3,
            hour12: false,
        };

        // Format the date in the specified time zone
        const formatter = new Intl.DateTimeFormat('en-US', options);
        const formattedParts = formatter.formatToParts(date);

        // Extract formatted parts
        const year = formattedParts.find(part => part.type === 'year').value;
        const month = formattedParts.find(part => part.type === 'month').value;
        const day = formattedParts.find(part => part.type === 'day').value;
        const hour = formattedParts.find(part => part.type === 'hour').value;
        const minute = formattedParts.find(part => part.type === 'minute').value;
        const second = formattedParts.find(part => part.type === 'second').value;
        const fraction = formattedParts.find(part => part.type === 'fractionalSecond').value;

        // Get the UTC equivalent of the time in the specified timezone
        const utcString = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}.${fraction}Z`).toISOString();

        // Calculate the timezone offset by comparing the UTC time with the local time
        const timeZoneOffsetMs = date.getTime() - new Date(utcString).getTime();
        const timeZoneOffsetHours = timeZoneOffsetMs / (1000 * 60 * 60);

        // Format the timezone offset as ±hh:mm
        const offsetSign = timeZoneOffsetHours >= 0 ? '-' : '+';
        const absOffsetHours = Math.abs(timeZoneOffsetHours);
        const offsetHours = String(Math.floor(absOffsetHours)).padStart(2, '0');
        const offsetMinutes = String(Math.round((absOffsetHours % 1) * 60)).padStart(2, '0');

        return `${year}-${month}-${day}T${hour}:${minute}:${second}.${fraction}${offsetSign}${offsetHours}:${offsetMinutes}`;
    };

    const formatDateToYYYYMMDDHHMMSS = (dateString) => {
        // Convert the string to a Date object
        let date = new Date(dateString);

        // Extract the year, month, day, hours, minutes, and seconds
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1 and pad with zero
        let day = String(date.getDate()).padStart(2, '0');
        let hours = String(date.getHours()).padStart(2, '0');
        let minutes = String(date.getMinutes()).padStart(2, '0');
        let seconds = String(date.getSeconds()).padStart(2, '0');

        // Format the date as "YYYY-MM-DD HH:MM:SS"
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const convertToAMPM = (time) => {
        let [hours, minutes] = time.split(':').map(Number);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for midnight
        minutes = minutes < 10 ? '0' + minutes : minutes; // Pad minutes with leading zero if needed
        return `${hours}:${minutes} ${ampm}`;
    };

    const convertTo24Hour = (time) => {
        // Split the input time into time and period (AM/PM)
        let [timePart, period] = time.split(' ');

        // Split the time part into hours and minutes
        let [hours, minutes] = timePart.split(':').map(Number);

        if (period === 'PM' && hours !== 12) {
            hours += 12;
        } else if (period === 'AM' && hours === 12) {
            hours = 0;
        }

        // Format the hours and minutes to always be two digits
        hours = String(hours).padStart(2, '0');
        minutes = String(minutes).padStart(2, '0');

        // Return the formatted time
        return `${hours}:${minutes}`;
    };

    // Update polygon visualization on map (Optimization Item #2: useCallback)
    const updatePolygonOnMap = useCallback((points) => {
        if (!mapRef || points.length === 0) return;

        const pointsGeoJSON = {
            type: 'FeatureCollection',
            features: points.map((point, index) => ({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: point
                },
                properties: {
                    index: index
                }
            }))
        };

        const linesGeoJSON = {
            type: 'Feature',
            geometry: {
                type: 'LineString',
                coordinates: points
            }
        };

        try {
            // Add or update polygon drawing visualization
            if (mapRef.getSource('polygonDrawingSource')) {
                mapRef.getSource('polygonDrawingSource').setData(pointsGeoJSON);
                mapRef.getSource('polygonLinesSource').setData(linesGeoJSON);
            } else {
                // Add points source and layer
                mapRef.addSource('polygonDrawingSource', {
                    type: 'geojson',
                    data: pointsGeoJSON
                });

                mapRef.addLayer({
                    id: 'polygonPoints',
                    type: 'circle',
                    source: 'polygonDrawingSource',
                    paint: {
                        'circle-radius': 6,
                        'circle-color': '#088',
                        'circle-stroke-width': 2,
                        'circle-stroke-color': '#fff'
                    }
                });

                // Add lines source and layer
                mapRef.addSource('polygonLinesSource', {
                    type: 'geojson',
                    data: linesGeoJSON
                });

                mapRef.addLayer({
                    id: 'polygonLines',
                    type: 'line',
                    source: 'polygonLinesSource',
                    paint: {
                        'line-color': '#088',
                        'line-width': 2,
                        'line-dasharray': [2, 2]
                    }
                });
            }
        } catch (error) {
        }
    }, [mapRef]);

    // Handler for single clicks in polygon mode (Optimization Item #2: useCallback)
    const handleMapClick = useCallback((e) => {
        // Only handle single clicks in polygon mode
        if (geometryType !== 'polygon') {
            return;
        }

        // Keep full precision coordinates (don't round yet)
        // This matches circle behavior and improves intersection accuracy
        let latitude = e.lngLat.lat;
        let longitude = e.lngLat.lng;

        // If there's already a completed polygon and drawing is not active, don't automatically start a new one
        // User must explicitly clear the polygon first using the "Clear Polygon" button
        if (!isDrawingPolygon && circleGeoJSON && polygonPoints.length === 0) {
            return; // Don't start a new polygon automatically
        }

        // Enforce maximum 6 points for simple polygons
        const MAX_POLYGON_POINTS = 6;
        if (polygonPoints.length >= MAX_POLYGON_POINTS) {
            setPolygonError(`Maximum ${MAX_POLYGON_POINTS} points allowed. Click "Complete Polygon" to finish.`);
            return;
        }

        // Check for duplicate clicks by comparing rounded values (prevents mouse bounce)
        // Round to 5 decimal places (~1.1 meter precision) for comparison only
        const roundedLat = Number(latitude.toFixed(5));
        const roundedLng = Number(longitude.toFixed(5));

        const isDuplicate = polygonPoints.some(existingPoint => {
            const existingRoundedLng = Number(existingPoint[0].toFixed(5));
            const existingRoundedLat = Number(existingPoint[1].toFixed(5));
            return existingRoundedLng === roundedLng && existingRoundedLat === roundedLat;
        });

        if (isDuplicate) {
            return; // Skip this click
        }


        // Clear any previous error
        setPolygonError(null);

        // Add point to polygon with full precision
        const newPoints = [...polygonPoints, [longitude, latitude]];
        setPolygonPoints(newPoints);
        setIsDrawingPolygon(true);

        // Update the polygon visualization on map
        updatePolygonOnMap(newPoints);

        // Set the center to the first point if this is the first point
        if (newPoints.length === 1) {
            setNewPlace({ lat: latitude, long: longitude });
            setCircleCenter([longitude, latitude]);
        }

        // Show message when maximum points reached
        if (newPoints.length === MAX_POLYGON_POINTS) {
            setPolygonError(`Maximum ${MAX_POLYGON_POINTS} points reached. Click "Complete Polygon" to finish.`);
        }
    }, [geometryType, isDrawingPolygon, circleGeoJSON, polygonPoints, updatePolygonOnMap]);

    // Handler for double clicks in circle mode (Optimization Item #2: useCallback)
    const handleClick = useCallback(async (e) => {
        // Only handle double clicks in circle mode
        if (geometryType !== 'circle') {
            return;
        }

        let latitude = Number(Number(e.lngLat.lat).toFixed(6));
        let longitude = Number(Number(e.lngLat.lng).toFixed(6));

        // Circle mode - existing logic
        //console.log("handleClick");
        // reset detail bar to default view
        setDetailbarVisible(false);
        setView('detailbar');
        setAlert({
            visible: false,
            content: ''
        });
        setPreCheck(true);
        setDetailbarButtonVisible(true);

        setNewPlace({ lat: latitude, long: longitude });
        setCircleCenter([longitude, latitude]);
        setAltitude(0);
        setMaxAltitude(400); // reset back to 400ft

        // Optimization Item #3: Use cached geocoding and timezone functions
        const geocodeData = await fetchGeocodeCached(longitude, latitude);
        const placeName = geocodeData.features[0]?.place_name
            ? `${geocodeData.features[0]?.place_name}`
            : `Latitude: ${latitude}, Longitude: ${longitude}`;
        setAddressDetails(placeName);

        // Any errors fetching timezone and current time display in the detailed bar window
        const timezoneData = await fetchTimezoneCached(latitude, longitude);
        setSelectedTimeZone(timezoneData.timeZoneId);
        const loc_currentTime = getISOTimeInTimeZone(timezoneData.timeZoneId); //await fetchCurrentTime(timezoneData.timeZoneId);
        //console.log(loc_currentTime);

        // convert timezone date time to EEEE, MMMM d, yyyy 'at' HH:mm zzz format
        const formatString = "EEEE, MMMM d, yyyy 'at' HH:mm zzz";
        const formatted_loc_currentTime = formatInTimeZone(new Date(loc_currentTime), timezoneData.timeZoneId, formatString, { locale: enUS });
        setSelectedLocationDateTime(formatted_loc_currentTime);
        //console.log("selected location date time");

        //extract yyyy-mm-dd and hh:mm
        const iso_pattern = loc_currentTime.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}):/);
        const calendar_date = iso_pattern[1];
        const calendar_time = iso_pattern[2];

        ////console.log(`https://api.sunrise-sunset.org/json?lat=${latitude}&lng=${longitude}&date=${calendar_date}&timezone=${timezoneData.timeZoneId}`);

        // get sunrise and sunset time
        const suntime_response = await fetch(`https://api.sunrisesunset.io/json?lat=${latitude}&lng=${longitude}&date=${calendar_date}&timezone=${timezoneData.timeZoneId}`);
        const suntime_results = await suntime_response.json();
        setSuntime(suntime_results.results);

        setSelectedDate(calendar_date);
        setCurrentLocaDate(calendar_date);
        setSelectedTime(calendar_time);

        //const defaultTime = new Date(loc_currentTime);
        //console.log(convertToAMPM(calendar_time));
        setSelectedTimeMui(parse(convertToAMPM(calendar_time), 'h:mm a', new Date()));

        const futureDate = new Date();
        futureDate.setDate((new Date()).getDate() + 90);
        const formattedDate = futureDate.toISOString().split('T')[0];
        setMaxDate(formattedDate);


        //let circle = createGeoJSONCircle({lat: latitude, long: longitude}, radius / 3280.84, 250);
        //setCircleGeoJSON(circle);


        if (mapRef) {
            //console.log("set move");
            setSlideEvent(false);
            mapRef.scrollZoom.disable();

            mapRef.flyTo({
                center: [longitude, latitude],
                zoom: zoomLevel,
                essential: true,
            });
        }

        // Show nearby airports within 2NM
        showNearbyAirports(longitude, latitude);

        // Show nearby airspace classes within 2NM
        showNearbyAirspaceClasses(longitude, latitude);
    }, [geometryType, mapRef, zoomLevel]); // eslint-disable-line react-hooks/exhaustive-deps
    // Note: showNearbyAirports and showNearbyAirspaceClasses are stable functions, not included in deps

    const handleDateChange = (event) => {
        //console.log(event.target.value);
        setSelectedDate(event.target.value);
    };

    const handleDurationChange = (event) => {
        setDuration(event.target.value);
    };

    /**
     * Validates and fixes polygon topology to ensure it meets topological requirements:
     * - At least 3 non-equal vertices
     * - No duplicate vertices within tolerance (0.000001 degrees ~= 0.1m)
     * - No zero-length or sub-tolerance segments
     * - No self-intersections
     * - Exterior ring in clockwise order
     * - Maximum distance between any two points is 5 nautical miles
     * @param {Array} points - Array of [lng, lat] coordinates
     * @returns {Object} - { isValid: boolean, fixedPoints: Array, errors: Array }
     */
    const validateAndFixPolygonTopology = (points) => {
        const errors = [];
        const TOLERANCE = 0.00001; // ~1 meter (matches click tolerance)
        const MIN_SEGMENT_LENGTH = TOLERANCE;
        const MAX_DISTANCE_NM = 5; // 5 nautical miles
        const MAX_DISTANCE_KM = MAX_DISTANCE_NM * 1.852; // Convert to kilometers
        const COORDINATE_PRECISION = 5; // 5 decimal places = ~1.1 meter precision
        const MIN_POLYGON_POINTS = 3;
        const MAX_POLYGON_POINTS = 6;


        // Keep full precision coordinates (don't round - let BusinessLogic.js do final rounding)
        // This matches circle behavior and improves intersection accuracy

        // Rule 1: Check minimum and maximum vertices (3-6 points for simple polygons)
        if (points.length < MIN_POLYGON_POINTS) {
            errors.push(`Polygon must have at least ${MIN_POLYGON_POINTS} points`);
            return {isValid: false, fixedPoints: null, errors};
        }

        if (points.length > MAX_POLYGON_POINTS) {
            errors.push(`Polygon must have at most ${MAX_POLYGON_POINTS} points`);
            return {isValid: false, fixedPoints: null, errors};
        }

        // Rule 2 & 3: Remove duplicate/coincident vertices by comparing rounded values
        // Use temporary rounded values for comparison but keep original precision
        const cleanedPoints = [];
        for (let i = 0; i < points.length; i++) {
            const current = points[i];

            // Round to 5 decimals for comparison only
            const currentRounded = [
                Number(current[0].toFixed(COORDINATE_PRECISION)),
                Number(current[1].toFixed(COORDINATE_PRECISION))
            ];

            const isDuplicate = cleanedPoints.some(existing => {
                const existingRounded = [
                    Number(existing[0].toFixed(COORDINATE_PRECISION)),
                    Number(existing[1].toFixed(COORDINATE_PRECISION))
                ];
                // Compare rounded values to detect duplicates
                return existingRounded[0] === currentRounded[0] &&
                    existingRounded[1] === currentRounded[1];
            });

            if (!isDuplicate) {
                // Store original full-precision point
                cleanedPoints.push(current);
            } else {
            }
        }


        // Check again after cleaning
        if (cleanedPoints.length < 3) {
            errors.push('After removing duplicates, polygon has less than 3 unique points');
            return {isValid: false, fixedPoints: null, errors};
        }

        // Rule 4: Check segment lengths (no zero-length or sub-tolerance segments)
        for (let i = 0; i < cleanedPoints.length; i++) {
            const p1 = cleanedPoints[i];
            const p2 = cleanedPoints[(i + 1) % cleanedPoints.length];
            const segmentLength = Math.sqrt(
                Math.pow(p2[0] - p1[0], 2) +
                Math.pow(p2[1] - p1[1], 2)
            );

            if (segmentLength < MIN_SEGMENT_LENGTH) {
                errors.push(`Segment ${i} is too short (${segmentLength.toFixed(8)}). Minimum length is ${MIN_SEGMENT_LENGTH}`);
            }
        }

        if (errors.length > 0) {
            return {isValid: false, fixedPoints: null, errors};
        }

        // Rule 5: Check maximum distance between any two points (5 nautical miles)
        let maxDistance = 0;
        let maxDistancePoints = null;

        for (let i = 0; i < cleanedPoints.length; i++) {
            for (let j = i + 1; j < cleanedPoints.length; j++) {
                const point1 = turf.point(cleanedPoints[i]);
                const point2 = turf.point(cleanedPoints[j]);
                const distance = turf.distance(point1, point2, {units: 'kilometers'});

                if (distance > maxDistance) {
                    maxDistance = distance;
                    maxDistancePoints = {i, j, distance};
                }
            }
        }

        const maxDistanceNM = maxDistance / 1.852; // Convert km to nautical miles

        if (maxDistance > MAX_DISTANCE_KM) {
            errors.push(
                `Maximum distance between any two points is ${maxDistanceNM.toFixed(2)} NM ` +
                `(between point ${maxDistancePoints.i + 1} and point ${maxDistancePoints.j + 1}). ` +
                `Maximum allowed is ${MAX_DISTANCE_NM} NM. Please draw a smaller polygon.`
            );
            return {isValid: false, fixedPoints: null, errors};
        }

        // Close the polygon by adding first point at end
        const closedPoints = [...cleanedPoints, cleanedPoints[0]];

        try {
            // Create GeoJSON polygon for validation
            const testPolygon = turf.polygon([closedPoints]);

            // Rule 6: Check for self-intersections using turf.kinks
            const kinks = turf.kinks(testPolygon);
            if (kinks.features.length > 0) {
                errors.push(`Polygon has ${kinks.features.length} self-intersection(s). Please redraw without crossing lines.`);
                return {isValid: false, fixedPoints: null, errors};
            }

            // Rule 7: Ensure clockwise winding order for exterior ring
            // turf.rewind ensures exterior rings are counter-clockwise (GeoJSON standard)
            // But for ArcGIS/Esri, we need clockwise for exterior rings
            // Check current winding order
            const area = turf.area(testPolygon);
            const isClockwise = turf.booleanClockwise(turf.getCoords(testPolygon)[0]);


            let finalPoints = closedPoints;

            // If not clockwise, reverse it (for ArcGIS/Esri topology)
            if (!isClockwise) {
                // Reverse all points except the closing point, then add first point again
                const reversedOpen = [...cleanedPoints].reverse();
                finalPoints = [...reversedOpen, reversedOpen[0]];
            }

            return {
                isValid: true,
                fixedPoints: finalPoints,
                errors: []
            };

        } catch (error) {
            errors.push(`Geometry validation error: ${error.message}`);
            return {isValid: false, fixedPoints: null, errors};
        }
    };

    const handleCompletePolygon = useCallback(async () => {

        if (polygonPoints.length < 3) {
            setPolygonError('Please add at least 3 points to create a polygon.');
            return;
        }

        if (polygonPoints.length > 6) {
            setPolygonError('Polygon can have at most 6 points. Please clear and redraw.');
            return;
        }

        // Validate and fix polygon topology
        const validation = validateAndFixPolygonTopology(polygonPoints);

        if (!validation.isValid) {
            setPolygonError(validation.errors.join('\n'));
            return;
        }

        // Validation passed — clear any previous error
        setPolygonError(null);

        // Use the validated and fixed polygon points
        const closedPolygon = validation.fixedPoints;

        // Create GeoJSON polygon
        const polygonGeoJSON = {
            type: 'Feature',
            geometry: {
                type: 'Polygon',
                coordinates: [closedPolygon]
            }
        };


        // Clear drawing visualization
        if (mapRef) {
            if (mapRef.getLayer('polygonPoints')) {
                mapRef.removeLayer('polygonPoints');
            }
            if (mapRef.getLayer('polygonLines')) {
                mapRef.removeLayer('polygonLines');
            }
            if (mapRef.getSource('polygonDrawingSource')) {
                mapRef.removeSource('polygonDrawingSource');
            }
            if (mapRef.getSource('polygonLinesSource')) {
                mapRef.removeSource('polygonLinesSource');
            }

            // Add the completed polygon to the map

            // Clear existing polygon visualization
            if (mapRef.getLayer('circleOutline')) {
                mapRef.removeLayer('circleOutline');
            }
            if (mapRef.getLayer('circleLayer')) {
                mapRef.removeLayer('circleLayer');
            }
            if (mapRef.getSource('circleSource')) {
                mapRef.removeSource('circleSource');
            }

            // Add polygon source and layers
            mapRef.addSource('circleSource', {
                type: 'geojson',
                data: polygonGeoJSON
            });

            mapRef.addLayer({
                'id': 'circleLayer',
                'type': 'fill',
                'source': 'circleSource',
                'paint': {
                    'fill-color': '#088',
                    'fill-opacity': 0.3
                }
            });

            mapRef.addLayer({
                'id': 'circleOutline',
                'type': 'line',
                'source': 'circleSource',
                'paint': {
                    'line-color': '#088',
                    'line-width': 2
                }
            });


            // Auto-zoom to polygon bounding box
            const lngs = polygonPoints.map(coord => coord[0]);
            const lats = polygonPoints.map(coord => coord[1]);
            const bounds = [
                [Math.min(...lngs), Math.min(...lats)], // Southwest coordinates
                [Math.max(...lngs), Math.max(...lats)]  // Northeast coordinates
            ];

            mapRef.fitBounds(bounds, {
                padding: {top: 100, bottom: 100, left: 100, right: 100},
                duration: 1500,
                essential: true
            });
        }

        // Calculate center point for the polygon
        const lngs = polygonPoints.map(coord => coord[0]);
        const lats = polygonPoints.map(coord => coord[1]);
        const centerLng = (Math.min(...lngs) + Math.max(...lngs)) / 2;
        const centerLat = (Math.min(...lats) + Math.max(...lats)) / 2;

        // Reset detail bar state
        setDetailbarVisible(false);
        setView('detailbar');
        setAlert({
            visible: false,
            content: ''
        });
        setPreCheck(true);
        setDetailbarButtonVisible(true);

        // Set center location
        setNewPlace({ lat: centerLat, long: centerLng });
        setCircleCenter([centerLng, centerLat]);
        setAltitude(0);
        setMaxAltitude(400);

        // Fetch location data (address, timezone, time) for the polygon center
        try {
            // Optimization Item #3: Use cached geocoding and timezone
            const geocodeData = await fetchGeocodeCached(centerLng, centerLat);
            const placeName = geocodeData.features[0]?.place_name
                ? `${geocodeData.features[0]?.place_name}`
                : `Latitude: ${centerLat}, Longitude: ${centerLng}`;
            setAddressDetails(placeName);

            // Fetch timezone and current time
            const timezoneData = await fetchTimezoneCached(centerLat, centerLng);
            setSelectedTimeZone(timezoneData.timeZoneId);
            const loc_currentTime = getISOTimeInTimeZone(timezoneData.timeZoneId);

            // Convert timezone date time to formatted string
            const formatString = "EEEE, MMMM d, yyyy 'at' HH:mm zzz";
            const formatted_loc_currentTime = formatInTimeZone(new Date(loc_currentTime), timezoneData.timeZoneId, formatString, { locale: enUS });
            setSelectedLocationDateTime(formatted_loc_currentTime);

            // Extract date and time
            const iso_pattern = loc_currentTime.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}):/);
            const calendar_date = iso_pattern[1];
            const calendar_time = iso_pattern[2];

            // Get sunrise and sunset time
            const suntime_response = await fetch(`https://api.sunrisesunset.io/json?lat=${centerLat}&lng=${centerLng}&date=${calendar_date}&timezone=${timezoneData.timeZoneId}`);
            const suntime_results = await suntime_response.json();
            setSuntime(suntime_results.results);

            setSelectedDate(calendar_date);
            setCurrentLocaDate(calendar_date);
            setSelectedTime(calendar_time);
            setSelectedTimeMui(parse(convertToAMPM(calendar_time), 'h:mm a', new Date()));
            setSelectedDateMui(new Date(calendar_date));

            const futureDate = new Date();
            futureDate.setDate((new Date()).getDate() + 90);
            const formattedDate = futureDate.toISOString().split('T')[0];
            setMaxDate(formattedDate);
        } catch (error) {
        }

        // Set the polygon as the circle GeoJSON (reusing the same state)
        setCircleGeoJSON(polygonGeoJSON);

        // Stop drawing mode
        setIsDrawingPolygon(false);

        // Clear polygon points so user can start a new polygon on next click
        setPolygonPoints([]);

        // Trigger the detail bar logic to fetch advisories
        setLoadParamLogic(true);
    }, [polygonPoints, mapRef]); // eslint-disable-line react-hooks/exhaustive-deps
    // Note: validateAndFixPolygonTopology is a stable function, not included in deps

    const handleClearPolygon = useCallback(() => {
        setPolygonPoints([]);
        setCircleGeoJSON(null);
        setIsDrawingPolygon(false);
        setPolygonError(null);

        // Remove polygon markers and lines from map
        if (mapRef) {
            // Remove drawing visualization layers
            if (mapRef.getLayer('polygonPoints')) {
                mapRef.removeLayer('polygonPoints');
            }
            if (mapRef.getLayer('polygonLines')) {
                mapRef.removeLayer('polygonLines');
            }
            if (mapRef.getSource('polygonDrawingSource')) {
                mapRef.removeSource('polygonDrawingSource');
            }
            if (mapRef.getSource('polygonLinesSource')) {
                mapRef.removeSource('polygonLinesSource');
            }

            // Remove completed polygon if exists
            if (mapRef.getLayer('circleOutline')) {
                mapRef.removeLayer('circleOutline');
            }
            if (mapRef.getLayer('circleLayer')) {
                mapRef.removeLayer('circleLayer');
            }
            if (mapRef.getSource('circleSource')) {
                mapRef.removeSource('circleSource');
            }
        }
    }, [mapRef]);

    const getFormattedDate = () => {
        if (selectedDate) {
            const date = new Date(selectedDate);
            return date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
        }
        return '';
    };

    const getFormattedTime = () => {
        if (selectedTime) {
            const timeParts = selectedTime.split(':');
            const date = new Date();
            date.setHours(parseInt(timeParts[0]));
            date.setMinutes(parseInt(timeParts[1]));
            return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
        }
        return '';
    };

    // circle layer identification helper functions
    const calculateIntermediatePoints = (center, points, radiusFeet) => {

        const intervalFeet = radiusFeet < 100 ? 10 : 100; // Set interval based on radius

        let intermediatePoints = [];
        points.forEach(([longitude, latitude]) => {
            intermediatePoints.push(getIntermediatePoints(center, [longitude, latitude], intervalFeet));
        });

        return intermediatePoints;
    };

    const getIntermediatePoints = (start, end, intervalFeet) => {
        const earthRadiusFeet = 20902200; // Radius of the Earth in feet
        const distanceFeet = calculateHaversineDistance(start, end); // Distance between start and end in feet
        const numberOfIntervals = Math.floor(distanceFeet / intervalFeet);
        const intermediatePoints = [];

        for (let i = 1; i <= numberOfIntervals; i++) {
            const fraction = i / (numberOfIntervals + 1);
            const [longitude, latitude] = interpolatePoints(start, end, fraction);
            intermediatePoints.push([longitude, latitude]);
        }

        return intermediatePoints;
    };

    const interpolatePoints = (start, end, fraction) => {
        const [startLongitude, startLatitude] = start;
        const [endLongitude, endLatitude] = end;

        const longitude = startLongitude + fraction * (endLongitude - startLongitude);
        const latitude = startLatitude + fraction * (endLatitude - startLatitude);

        return [longitude, latitude];
    };

    const calculateHaversineDistance = ([longitude1, latitude1], [longitude2, latitude2]) => {
        const earthRadiusFeet = 20902200; // Radius of the Earth in feet
        const phi1 = latitude1 * (Math.PI / 180);
        const phi2 = latitude2 * (Math.PI / 180);
        const deltaPhi = (latitude2 - latitude1) * (Math.PI / 180);
        const deltaLambda = (longitude2 - longitude1) * (Math.PI / 180);

        const a = Math.sin(deltaPhi / 2) ** 2 + Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) ** 2;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return earthRadiusFeet * c; // Distance in feet
    };
    // end circle layer identification helper functions


    // const isCurrentDateInPast = (isoDateString, customDateString) => {
    //     // Parse the ISO date string into a Date object
    //     const isoDate = new Date(isoDateString); //in the format 2024-08-27T03:59:43.742-06:00
    //     const timezoneOffset = isoDateString.slice(-6);
    //     //console.log(isoDateString);
    //     //console.log(isoDate.toISOString()); // selected location time converted to
    //
    //
    //     // Parse the custom date string into a Date object
    //     const [customDatePart, customTimePart] = customDateString.split(" ");
    //     const [customYear, customMonth, customDay] = customDatePart.split("-").map(Number);
    //     const [customHour, customMinute] = customTimePart.split(":").map(Number);
    //
    //     // Create a new Date object for the custom date
    //     const customDate = new Date(customYear, customMonth - 1, customDay, customHour, customMinute);
    //
    //     //console.log(customDateString); // 2024-08-27 03:59
    //     //console.log(customDate);
    //     //console.log(customDate.toISOString());
    //
    //     // Ensure both dates are valid
    //     if (isNaN(isoDate.getTime()) || isNaN(customDate.getTime())) {
    //         throw new Error("Invalid date string");
    //     }
    //
    //     // Compare the dates
    //     if (isoDate.getTime() > customDate.getTime()) {
    //         // ISO date is in the future compared to custom date
    //         return false;
    //     } else {
    //         // ISO date is in the past or equal to the custom date
    //         return true;
    //     }
    // }
    const isCurrentDateInPast = (selectedLocationTimeString, detailbarSelectedTimeString) => {
        // Parse the ISO date string into a Date object
        const isoDate = new Date(selectedLocationTimeString); //in the format 2024-08-27T03:59:43.742-06:00
        const selectedLocationTime_UTC = isoDate.toISOString();
        const timezoneOffset = selectedLocationTimeString.slice(-6);
        // //console.log(timezoneOffset);
        // //console.log(isoDateString);
        // //console.log(isoDate.toISOString()); // selected location time converted to
        // Extract date and time parts
        const [datePart, timePart] = detailbarSelectedTimeString.split(' ');
        const [year, month, day] = datePart.split('-');
        const [hour, minute] = timePart.split(':');
        // Default values for seconds and milliseconds
        const seconds = '00'; // Default seconds
        const milliseconds = '000'; // Default milliseconds
        // Construct the final ISO string manually
        // const customDateString_iso = `${year}-${month}-${day}T${hour}:${minute}:${seconds}.${milliseconds}${timezoneOffset}`;
        const detailbarSelectedTime_UTC = new Date(`${year}-${month}-${day}T${hour}:${minute}:${seconds}.${milliseconds}${timezoneOffset}`).toISOString();

        // Convert ISO strings to Date objects
        const date1 = new Date(selectedLocationTime_UTC);
        const date2 = new Date(detailbarSelectedTime_UTC);

        return date1 > date2;
    }

    // user selected point and circle/polygon area
    useEffect(() => {
        // double click event or parameter change event
        // Also trigger if we have circleGeoJSON (from template) and required params
        if (mapRef && mapTilesLoaded && styleLoaded && (loadDetailBarLogic || (loadParamLogic && (circleGeoJSON || radius || selectedDate || selectedTime || duration)))) {


            // Ensure newPlace is set (required for BusinessLogic)
            if (!newPlace) {
                return;
            }


            // for double click event
            if (loadDetailBarLogic) {
                setLoadDetailBarLogic(false);
            }

            // Draw geometry based on mode
            let geometryGeoJSON = null;

            // Check if we have template geometry in ref (handles timing issues)
            const templateGeom = templateGeometryRef.current || circleGeoJSON;

            if (geometryType === 'circle') {
                // Only use template geometry on initial load, not when user adjusts radius
                const isInitialTemplateLoad = templateGeom && loadParamLogic && !loadDetailBarLogic;

                if (isInitialTemplateLoad && !circleGeoJSON) {
                    // Template initial load - use template geometry only if we haven't created a circle yet
                    geometryGeoJSON = templateGeom;

                    // Clear the ref now that we've used it
                    if (templateGeometryRef.current) {
                        templateGeometryRef.current = null;
                    }
                } else if (newPlace) {
                    // Draw new circle (from user click, radius change, or when switching from polygon)
                    let circleCreated = createGeoJSONCircle(newPlace, radius / 3280.84, 150);
                    setCircleGeoJSON(circleCreated);
                    geometryGeoJSON = circleCreated;
                    //console.log(circleCreated);
                    //
                    // Clear existing layers before adding new ones
                    if (mapRef.getLayer('circleOutline')) {
                        mapRef.removeLayer('circleOutline');
                    }
                    if (mapRef.getLayer('circleLayer')) {
                        mapRef.removeLayer('circleLayer');
                    }
                    if (mapRef.getSource('circleSource')) {
                        mapRef.removeSource('circleSource');
                    }

                    mapRef.addSource('circleSource', { type: 'geojson', data: circleCreated });
                    mapRef.addLayer({
                        'id': 'circleLayer',
                        'type': 'fill',
                        'source': 'circleSource',
                        'paint': {
                            'fill-color': '#088',
                            'fill-opacity': 0.3
                        }
                    });
                    // Add outline for better visibility
                    mapRef.addLayer({
                        'id': 'circleOutline',
                        'type': 'line',
                        'source': 'circleSource',
                        'paint': {
                            'line-color': '#088',
                            'line-width': 2
                        }
                    });
                    // end draw circle ========================================
                } else {
                }
            } else if (geometryType === 'polygon' && templateGeom) {
                // Use existing polygon from circleGeoJSON or templateRef
                geometryGeoJSON = templateGeom;

                // Clear the ref now that we've used it
                if (templateGeometryRef.current) {
                    templateGeometryRef.current = null;
                }
            }

            // Skip if no geometry available
            if (!geometryGeoJSON) {
                return;
            }

            // Normalize geometry structure - handle both Feature and direct geometry formats
            let normalizedGeometry;
            if (geometryGeoJSON.type === 'Feature') {
                // Feature format: { type: 'Feature', geometry: { type: 'Polygon', coordinates: [...] } }
                normalizedGeometry = geometryGeoJSON;
            } else if (geometryGeoJSON.type === 'Polygon' || geometryGeoJSON.type === 'LineString') {
                // Direct geometry format: { type: 'Polygon', coordinates: [...] }
                // Wrap it in a Feature
                normalizedGeometry = {
                    type: 'Feature',
                    geometry: geometryGeoJSON
                };
            } else {
                return;
            }


            // Verify we have the coordinates
            if (!normalizedGeometry.geometry || !normalizedGeometry.geometry.coordinates) {
                return;
            }

            // Query layers at all points of the geometry
            let all_layers_filtered = [];
            let point_circle_coords = normalizedGeometry.geometry.coordinates[0];

            // Get LAANC layers excluding 3D models to prevent getModel() errors
            const mapLayers = mapRef.getStyle().layers;
            const laancLayerIds = mapLayers
                .filter(layer => layer.type !== 'model' && layer.id.toLowerCase().includes("laanc-"))
                .map(layer => layer.id);

            point_circle_coords.forEach(coord => {
                // //console.log(coord);
                const [lng, lat] = coord;
                const sizeInDegrees = 0.00001;
                // Define the southwest (bottom-left) and northeast (top-right) corners of the bounds
                const southwest = new mapboxgl.LngLat(lng - sizeInDegrees / 2, lat - sizeInDegrees / 2); // Bottom-left corner
                const northeast = new mapboxgl.LngLat(lng + sizeInDegrees / 2, lat + sizeInDegrees / 2); // Top-right corner
                let bounds = new mapboxgl.LngLatBounds(southwest, northeast);

                const northEastPointPixel = mapRef.project(bounds.getNorthEast());
                const southWestPointPixel = mapRef.project(bounds.getSouthWest());

                try {
                    // Only query LAANC layers to avoid 3D model layer errors
                    // Skip query if no LAANC layers to avoid querying all layers including 3D models
                    if (laancLayerIds.length === 0) {
                        return;
                    }

                    const featuresBound = mapRef.queryRenderedFeatures([southWestPointPixel, northEastPointPixel], {
                        layers: laancLayerIds,
                        validate: false
                    });

                    //console.log(featuresBound);

                    // Optimization Item #5: Combine 4 filter passes into 1 for 60-80% faster filtering
                    const temp_layers = featuresBound
                        .filter(feature => {
                            // Combine all conditions into single pass
                            if (!feature || !feature.layer || !feature.source) return false;
                            if (!feature.layer.id.toLowerCase().includes("laanc-")) return false;
                            return feature.source === 'composite' ||
                                   feature.source === 'laanc-tfr' ||
                                   feature.source === 'laanc-seams' ||
                                   feature.source.includes('b4ufly');
                        })
                        .map(feature => ({ layerId: feature.layer.id.toLowerCase(), properties: feature.properties }));
                    all_layers_filtered.push(...temp_layers)
                } catch (error) {
                }
            });

            // second option
            let uniqueLayerNames = [];

            const circle_coords = normalizedGeometry.geometry.coordinates[0];
            // OPTIMIZED: Query once using the full circle bounds instead of 150 separate queries
            // Create a single bounding box that encompasses the entire circle
            const circleBounds = new mapboxgl.LngLatBounds();
            for (const coord of circle_coords) {
                circleBounds.extend(coord);
            }

            try {
                // Only query LAANC layers to avoid 3D model layer errors
                // Skip query if no LAANC layers to avoid querying all layers including 3D models
                if (laancLayerIds.length === 0) {
                    return;
                }

                const northEastPointPixel = mapRef.project(circleBounds.getNorthEast());
                const southWestPointPixel = mapRef.project(circleBounds.getSouthWest());

                const features = mapRef.queryRenderedFeatures([southWestPointPixel, northEastPointPixel], {
                    layers: laancLayerIds,
                    validate: false
                });

                // Create a turf polygon from the circle coordinates for intersection testing
                const circlePolygon = turf.polygon([circle_coords]);

                // Optimization Item #5: Combine 4 filter passes into 1 for 60-80% faster filtering
                const temp_layers = features
                    .filter(feature => {
                        // Combine all basic validation checks into single pass
                        if (!feature || !feature.layer || !feature.source) return false;
                        if (!feature.layer.id.toLowerCase().includes("laanc-")) return false;

                        const validSource = feature.source === 'composite' ||
                                          feature.source === 'laanc-tfr' ||
                                          feature.source === 'laanc-seams' ||
                                          feature.source.includes('b4ufly');
                        if (!validSource) return false;

                        // Post-filter: Check if the feature actually intersects with the circle
                        // Only process features with geometry
                        if (!feature.geometry || !feature.geometry.coordinates) {
                            return true; // Keep features without geometry (e.g., labels)
                        }

                        try {
                            // Create a turf feature from the mapbox feature
                            let turfFeature;
                            if (feature.geometry.type === 'Polygon') {
                                turfFeature = turf.polygon(feature.geometry.coordinates);
                            } else if (feature.geometry.type === 'MultiPolygon') {
                                turfFeature = turf.multiPolygon(feature.geometry.coordinates);
                            } else if (feature.geometry.type === 'LineString') {
                                turfFeature = turf.lineString(feature.geometry.coordinates);
                            } else if (feature.geometry.type === 'Point') {
                                turfFeature = turf.point(feature.geometry.coordinates);
                            } else {
                                return true; // Keep other geometry types
                            }

                            // Check if the feature intersects with the circle
                            // Use booleanOverlap for polygons or booleanIntersects as fallback
                            if (feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiPolygon') {
                                return turf.booleanOverlap(turfFeature, circlePolygon) ||
                                       turf.booleanWithin(turfFeature, circlePolygon) ||
                                       turf.booleanWithin(circlePolygon, turfFeature);
                            } else {
                                // For lines and points, check if they're within the circle
                                return turf.booleanWithin(turfFeature, circlePolygon) ||
                                       turf.booleanIntersects(turfFeature, circlePolygon);
                            }
                        } catch (err) {
                            // If there's an error checking intersection, keep the feature to be safe
                            console.warn('Error checking feature intersection with circle:', err);
                            return true;
                        }
                    })
                    .map(feature => ({layerId: feature.layer.id.toLowerCase(), properties: feature.properties}));

                all_layers_filtered.push(...temp_layers);
            } catch (error) {
            }

            // Optimization Item #5: Remove JSON.stringify for faster deduplication (2-3x faster)
            // Create a simple hash from key properties instead of stringifying the whole object
            uniqueLayerNames = [
                ...new Map(all_layers_filtered.map(item => {
                    // Use key properties for hash instead of JSON.stringify
                    const props = item.properties || {};
                    const hashKey = `${item.layerId}|${props.OBJECTID || ''}|${props.IDENT || ''}|${props.NAME || ''}|${props.notam_id || ''}`;
                    return [hashKey, item];
                })).values()
            ];


            // end preprocessing logic =========================================

            // Find layers within 2NM BEFORE running business logic
            // Wrap in async IIFE since useEffect cannot be async
            (async () => {
                let proximity2NMResults = [];

                // Validate newPlace has valid coordinates before calling proximity filter
                if (newPlace &&
                    typeof newPlace.lat === 'number' &&
                    typeof newPlace.long === 'number' &&
                    !isNaN(newPlace.lat) &&
                    !isNaN(newPlace.long)) {

                    try {
                        proximity2NMResults = await findLayersWithin2NM(
                            {lng: newPlace.long, lat: newPlace.lat},
                            mapboxgl.accessToken,
                            normalizedGeometry,
                            mapRef // Pass map reference to use cached sources
                        );
                    } catch (error) {
                        console.error("[Home.js] Error finding layers within 2NM:", error);
                    }
                } else {
                    console.warn("[Home.js] Skipping 2NM proximity filter - invalid coordinates:", newPlace);
                }

                // Call BusinessLogic (Optimization Item #6: already optimized via useEffect dependencies)
                // The useEffect dependencies ensure this only runs when needed
                const additionalDetails = BusinessLogic(
                    uniqueLayerNames,
                    selectedLocationDateTime,
                    newPlace,
                    duration,
                    selectedDate,
                    selectedTime,
                    selectedTimeZone,
                    selectedPurpose,
                    suntime,
                    airportData,
                    mapRef,
                    normalizedGeometry,
                    proximity2NMResults // Pass 2NM results to business logic
                );


                // re-set altitude values based on business logic details
                //console.log("setting max altitude:" + additionalDetails.maxAltitude);
                // setAltitude(0);
                setMaxAltitude(additionalDetails.maxAltitude);
                additionalDetails.radius = radius;
                setDetailbarContent({
                    placeName: addressDetails,
                    layers: additionalDetails,
                    properties: [],
                    loc_currentTime: selectedLocationDateTime
                });

                if (authenticated && profile) {
                    preCheckOverlappingTime({
                        selected_date_time: formatDateToYYYYMMDDHHMMSS(additionalDetails.timestamps.startDateTime),
                        op_end_datetime: formatDateToYYYYMMDDHHMMSS(additionalDetails.timestamps.endDateTime),
                        selected_timezone: selectedTimeZone
                    });
                    prechekInvalidCheck();
                    isEmailVerified(profile.email);
                }

                // Show nearby airports within 2NM
                if (newPlace && newPlace.long !== undefined && newPlace.lat !== undefined) {
                    showNearbyAirports(newPlace.long, newPlace.lat);
                    showNearbyAirspaceClasses(newPlace.long, newPlace.lat);
                }

                setDetailbarVisible(true);

                if (loadParamLogic)
                    setLoadParamLogic(false);

            })(); // Close async IIFE

        }

    }, [loadDetailBarLogic, loadParamLogic, selectedDate, selectedTime, duration, selectedPurpose, mapTilesLoaded, styleLoaded, radius, geometryType]);
    //[circleGeoJSON, selectedDate, selectedTime, duration]

    const activateGeolocate = () => {
        if (!navigator.geolocation) {
            alert("Geolocation is not supported by your browser.");
            return;
        }

        if (!mapRef) {
            alert("Map is not ready yet. Please wait a moment and try again.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                try {
                    const { coords } = position;
                    const { latitude, longitude } = coords;

                    setMarkerVisible(false);
                    const locationIcon = document.createElement('div');
                    locationIcon.className = 'custom_location_icon';
                    locationIcon.style.backgroundImage = `url(${locationicon})`;
                    locationIcon.style.width = '55px';
                    locationIcon.style.height = '55px';

                    setMarkerVisible(true);
                    setNewPlace({ lat: latitude, long: longitude });
                    setCircleCenter([longitude, latitude]);

                    // Fly to the current location
                    if (mapRef && mapRef.flyTo) {
                        mapRef.flyTo({
                            center: [longitude, latitude],
                            zoom: 14,
                            essential: true
                        });
                    }
                } catch (error) {
                    console.error('[Geolocation] Error processing location:', error);
                    alert('Failed to process your location. Please try again.');
                }
            },
            (error) => {
                console.error('[Geolocation] Error getting position:', error);
                let errorMessage = 'Unable to retrieve your location. ';

                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        errorMessage += 'Location permission was denied. Please enable location access in your browser settings.';
                        break;
                    case error.POSITION_UNAVAILABLE:
                        errorMessage += 'Location information is unavailable.';
                        break;
                    case error.TIMEOUT:
                        errorMessage += 'Location request timed out. Please try again.';
                        break;
                    default:
                        errorMessage += 'An unknown error occurred.';
                }

                alert(errorMessage);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    };


    /* Lat, Lng search capability
     * https://github.com/mapbox/carmen/blob/master/carmen-geojson.md */
    const coordinatesGeocoder = (query) => {

        setDetailbarVisible(false);
        // Match anything which looks like
        // decimal degrees coordinate pair.
        const matches = query.match(
            /^[ ]*(?:Lat: )?(-?\d+\.?\d*)[, ]+(?:Lng: )?(-?\d+\.?\d*)[ ]*$/i
        );
        if (!matches) {
            return null;
        }

        function coordinateFeature(lng, lat) {
            return {
                center: [lng, lat],
                geometry: {
                    type: 'Point',
                    coordinates: [lng, lat]
                },
                place_name: 'Lat: ' + lat + ' Lng: ' + lng,
                place_type: ['coordinate'],
                properties: {},
                type: 'Feature'
            };
        }

        const coord1 = Number(matches[1]);
        const coord2 = Number(matches[2]);
        const geocodes = [];

        if (coord1 < -90 || coord1 > 90) {
            // must be lng, lat
            geocodes.push(coordinateFeature(coord1, coord2));
        }

        if (coord2 < -90 || coord2 > 90) {
            // must be lat, lng
            geocodes.push(coordinateFeature(coord2, coord1));
        }

        if (geocodes.length === 0) {
            // else could be either lng, lat or lat, lng
            geocodes.push(coordinateFeature(coord1, coord2));
            geocodes.push(coordinateFeature(coord2, coord1));
        }

        return geocodes;
    };

    // geocoder
    useEffect(() => {
        if (mapRef && geocoder === null) {
            geocoder = new MapboxGeocoder({
                accessToken: 'pk.eyJ1IjoidGhpbGFua2FkYW1pdGgiLCJhIjoiY2x6Y3Izb3liMGVoODJpb2hjemcyZ21iMyJ9.cmoQD4aNYtU4KuTeVd5cKg',
                countries: 'us', // Restrict search results to the United States
                mapboxgl: mapboxgl,
                localGeocoder: coordinatesGeocoder,
                placeholder: "Enter Location or Coordinates",
                marker: false,
            });
            // TODO: check whether geocoder exist
            mapRef.addControl(geocoder);
        }
    }, [mapRef]);

    useEffect(() => {
        //console.log(detailbarContent);
    }, [detailbarContent]);

    const loadOperations = async (formdata) => {

        // hide the button div so users can't select
        setDetailbarButtonVisible(false);
        try {
            // Pass organizationId for proper operation scoping
            const organizationId = currentOrganization?.organizationId || null;
            const newOperation = await submitOperation(token, formdata, profile.userId, organizationId);
            //console.log(newOperation);

            setAlert({
                visible: true,
                content: `Operation successfully created.\n Confirmation email was sent to ${formdata.operator_email}. Please check Mission Logs to view operation status.` + (detailbarContent.layers.authorizations_array.authorizations.length > 0 ? "\nYour request is currently pending; please refrain from contacting Air Traffic by phone, as this could lead to a denial of your request by the FAA." : ""),
                operationId: newOperation?.operationId ?? null,
            });

            // Keep the sidebar open so the confirmation alert remains visible.
            // It will be dismissed (and the sidebar closed) when the user clicks
            // "Close" or "Review in Mission Log".
            setView('detailbar');
            setDetailbarButtonVisible(false); // hide Next/Finish while alert is shown

            // Clear polygon mode if it was active
            if (geometryType === 'polygon') {
                handleClearPolygon();
                setGeometryType('circle'); // Reset to default circle mode
            }

        } catch (error) {
            // show error message
            // Re-enable buttons on error so user can retry
            setDetailbarButtonVisible(true);
            //TODO: show error message in the detail bar
        }
        setCaptchaValue(null);  // Reset reCAPTCHA
    };

    //pre check for overlapping time
    const preCheckOverlappingTime = async (formdata) => {
        try {
            //console.log("calling pre check");
            const precheck_return = await preCheckOperation(token, formdata.selected_date_time, formdata.op_end_datetime, formdata.selected_timezone, profile.userId);
            //console.log(precheck_return);
            if (precheck_return.count > 0) {
                setPreCheck(false);
            } else {
                setPreCheck(true);
            }
        } catch (error) {
        }
    };

    // invalid check
    const prechekInvalidCheck = async () => {
        try {
            //console.log("calling invalid pre check");
            const invalid_check = await preInvalidCheckOperation(token, profile.userId);
            //console.log(invalid_check);
            if (invalid_check.count > 0) {
                setPreInvalidCheck(false);
            } else {
                setPreInvalidCheck(true);
            }
        } catch (error) {
        }
    };

    const isEmailVerified = async (email) => {

        try {
            const is_verified = await isEmailVerifiedOperation(token, email);
            // console.log("email verified", is_verified);
            setIsUserEmailVerified(is_verified);

        } catch (error) {
        }

    };

    useEffect(() => {
        // reset detail bar to default view
        setDetailbarVisible(false);
        setView('detailbar');
        setAlert({
            visible: false,
            content: ''
        });
        setDetailbarButtonVisible(true);
    }, [selectedPurpose]);


    const handleCloseAlert = () => {
        setDetailbarVisible(false);
        setDetailbarButtonVisible(true);
        setAlert({visible: false, content: '', operationId: null});
    };

    const handleReviewOperation = () => {
        const opId = alert.operationId;
        setAlert({visible: false, content: '', operationId: null});
        navigate('/MissionLog', {state: {highlightOperationId: opId}});
    };

    // Helper function to parse lat/long from format "51-53-00.8980N" to decimal degrees
    const parseLatLong = (coord) => {
        // If already a number, return it
        if (typeof coord === 'number') return coord;

        // If it's a string that looks like a decimal number
        if (typeof coord === 'string' && !coord.match(/[NSEW]/)) {
            const decimal = parseFloat(coord);
            return isNaN(decimal) ? null : decimal;
        }

        // Parse DMS format: "51-53-00.8980N"
        const match = coord.match(/(\d+)-(\d+)-(\d+\.?\d*)([NSEW])/);
        if (!match) return null;

        const degrees = parseInt(match[1]);
        const minutes = parseInt(match[2]);
        const seconds = parseFloat(match[3]);
        const direction = match[4];

        let decimal = degrees + minutes / 60 + seconds / 3600;

        if (direction === 'S' || direction === 'W') {
            decimal = -decimal;
        }

        return decimal;
    };

    // Calculate distance in nautical miles between two points
    const calculateDistanceNM = (lat1, lon1, lat2, lon2) => {
        const R = 3440.065; // Earth's radius in nautical miles
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    };

    // Calculate bearing from point1 to point2 and return direction identifier
    const calculateBearing = (lat1, lon1, lat2, lon2) => {
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const y = Math.sin(dLon) * Math.cos(lat2 * Math.PI / 180);
        const x = Math.cos(lat1 * Math.PI / 180) * Math.sin(lat2 * Math.PI / 180) -
            Math.sin(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.cos(dLon);
        const bearing = Math.atan2(y, x) * 180 / Math.PI;
        const normalizedBearing = (bearing + 360) % 360;

        // Convert bearing to 8-directional identifiers
        // 0° = North, 90° = East, 180° = South, 270° = West
        if (normalizedBearing >= 337.5 || normalizedBearing < 22.5) return 'N'; // North
        if (normalizedBearing >= 22.5 && normalizedBearing < 67.5) return 'NE'; // Northeast
        if (normalizedBearing >= 67.5 && normalizedBearing < 112.5) return 'E'; // East
        if (normalizedBearing >= 112.5 && normalizedBearing < 157.5) return 'SE'; // Southeast
        if (normalizedBearing >= 157.5 && normalizedBearing < 202.5) return 'S'; // South
        if (normalizedBearing >= 202.5 && normalizedBearing < 247.5) return 'SW'; // Southwest
        if (normalizedBearing >= 247.5 && normalizedBearing < 292.5) return 'W'; // West
        if (normalizedBearing >= 292.5 && normalizedBearing < 337.5) return 'NW'; // Northwest
        return 'N';
    };

    // Display airports within 2NM of clicked location
    const showNearbyAirports = (clickedLng, clickedLat) => {
        if (!mapRef || !airportData || airportData.length === 0) {
            return;
        }

        // Clear previous markers and data
        airportMarkers.forEach(marker => marker.remove());
        setAirportMarkers([]);
        setNearbyAirportsData([]);

        // Find airports within 2NM with distance and direction
        const airportsWithDistance = airportData.map(airport => {
            const airportLat = parseLatLong(airport.LATITUDE);
            const airportLon = parseLatLong(airport.LONGITUDE);

            if (airportLat === null || airportLon === null) {
                return null;
            }

            const distance = calculateDistanceNM(clickedLat, clickedLng, airportLat, airportLon);
            const direction = calculateBearing(clickedLat, clickedLng, airportLat, airportLon);

            return {
                ...airport,
                lat: airportLat,
                lon: airportLon,
                distance: distance.toFixed(2),
                direction: direction
            };
        }).filter(airport => airport !== null && parseFloat(airport.distance) <= 2);

        // Sort by distance
        airportsWithDistance.sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));

        // Store for Advisories display
        setNearbyAirportsData(airportsWithDistance);

        // Create markers for nearby airports
        const newMarkers = airportsWithDistance.map(airport => {
            // Create marker element
            const el = document.createElement('div');
            el.className = 'airport-poi-marker';
            el.style.backgroundColor = '#1e40af';
            el.style.width = '16px';
            el.style.height = '16px';
            el.style.borderRadius = '50%';
            el.style.border = '2px solid white';
            el.style.cursor = 'pointer';

            // Create popup
            const popup = new mapboxgl.Popup({offset: 25})
                .setHTML(`
                    <div style="padding: 8px;">
                        <strong>${airport.NAME} (${airport.IDENT})</strong><br/>
                        <small>${airport.SERVCITY}, ${airport.STATE}</small><br/>
                        <small>Elevation: ${airport.ELEVATION} ft</small>
                    </div>
                `);

            // Create and add marker
            const marker = new mapboxgl.Marker(el)
                .setLngLat([airport.lon, airport.lat])
                .setPopup(popup)
                .addTo(mapRef);

            return marker;
        });

        setAirportMarkers(newMarkers);
    };

    // List airspace class layers within 2NM of clicked location
    const showNearbyAirspaceClasses = (clickedLng, clickedLat) => {
        if (!mapRef) return;

        // Clear previous airspace data
        setNearbyAirspaces([]);

        // Get all map layers
        const allLayers = mapRef.getStyle().layers;

        // Filter for layers containing 'laanc-airspace-class' in their name
        const airspaceClassLayers = allLayers.filter(layer =>
            layer.id && layer.id.includes('laanc-airspace-class')
        );

        // Collect all features from these layers
        const allFeatures = [];

        // OPTIMIZED: Query all airspace layers at once instead of one by one
        try {
            const features = mapRef.queryRenderedFeatures({
                layers: airspaceClassLayers.map(layer => layer.id)
            });

            if (features && features.length > 0) {
                allFeatures.push(...features);
            }
        } catch (error) {
            console.error('Error querying airspace layers:', error);
        }

        // Filter features within 2NM and get unique by NAME+CLASS combination
        const nearbyFeatures = [];
        const seenAirspaces = new Map(); // Use Map to track by NAME+CLASS and keep the closest one

        // OPTIMIZED: Create clickedPoint once outside the loop
        const clickedPoint = turf.point([clickedLng, clickedLat]);

        for (const feature of allFeatures) {
            try {
                // Skip features with invalid geometry
                if (!feature.geometry || !feature.geometry.coordinates || !feature.geometry.coordinates[0]) {
                    console.warn('Skipping feature with invalid geometry:', feature);
                    continue;
                }

                // Skip features with insufficient coordinates for lineString
                const coords = feature.geometry.coordinates[0];
                if (!Array.isArray(coords) || coords.length < 2) {
                    console.warn('Skipping feature with insufficient coordinates:', feature);
                    continue;
                }

                let dist;
                let direction = null;
                let nearestPointCoords = null;

                // Check if the clicked point is inside the polygon
                const isInside = turf.booleanPointInPolygon(clickedPoint, feature);

                if (isInside) {
                    // If inside the polygon, distance is 0
                    dist = 0;
                } else {
                    // If outside, calculate distance to the nearest point on the polygon boundary
                    // Get the polygon coordinates (boundary)
                    const line = turf.lineString(coords);
                    const nearestPoint = turf.nearestPointOnLine(line, clickedPoint);

                    // Calculate distance in kilometers, then convert to nautical miles
                    const distanceKm = turf.distance(clickedPoint, nearestPoint, {units: 'kilometers'});
                    dist = distanceKm * 0.539957; // Convert km to nautical miles

                    // Get nearest point coordinates and calculate bearing
                    nearestPointCoords = nearestPoint.geometry.coordinates;
                    direction = calculateBearing(clickedLat, clickedLng, nearestPointCoords[1], nearestPointCoords[0]);
                }

                // Check if within 2NM
                if (dist <= 2) {
                    const globalId = feature.properties.GLOBAL_ID;
                    const name = feature.properties.NAME || 'Unnamed';
                    const classType = feature.properties.CLASS || 'N/A';

                    // Create unique key based on NAME and CLASS to prevent duplicate display names
                    const uniqueKey = `${name}_${classType}`;

                    // Only add if we haven't seen this NAME+CLASS combination, or if this one is closer
                    if (!seenAirspaces.has(uniqueKey) || parseFloat(dist) < parseFloat(seenAirspaces.get(uniqueKey).distance)) {
                        const airspaceData = {
                            globalId: globalId,
                            distance: dist.toFixed(2),
                            layerId: feature.layer.id,
                            properties: feature.properties,
                            isInside: isInside,
                            direction: direction
                        };
                        seenAirspaces.set(uniqueKey, airspaceData);
                    }
                }
            } catch (error) {
                console.error('Error processing feature:', error);
            }
        }

        // Convert Map values to array
        nearbyFeatures.push(...Array.from(seenAirspaces.values()));

        // Sort by distance
        nearbyFeatures.sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));

        // Store in state for display in Advisories
        setNearbyAirspaces(nearbyFeatures);

        return nearbyFeatures;
    };


    useEffect(() => {

        if (mapRef) {
            // Handle map load event - use 'once' since it should only fire one time
            mapRef.once('load', () => {
                //console.log('Map loaded');

                // Preload GeoJSON cache for proximity filter
                preloadGeoJSONCache().catch(err => {
                    console.error('Failed to preload GeoJSON cache:', err);
                });

                // Wait for the style to be fully loaded including source metadata
                const addUasfmLabels = () => {
                    if (!mapRef.getLayer('text-uasfm-labels') && mapRef.isStyleLoaded()) {
                        mapRef.addLayer({
                            'id': 'text-uasfm-labels',
                            'type': 'symbol',
                            'source': 'composite',
                            "source-layer": ['qa', 'dev'].includes(process.env.REACT_APP_ENV) ? 'qa-laanc-uasfm' : 'laanc-uasfm',
                            'layout': {
                                'text-field': ['concat', ['get', 'CEILING'], "'"],
                                'text-variable-anchor': ['center'],
                                'text-size': 10,
                            }
                        });
                    }
                };

// Try to add immediately if style is already loaded
                if (mapRef.isStyleLoaded()) {
                    addUasfmLabels();
                } else {
// Otherwise wait for style to be loaded
                    mapRef.once('idle', addUasfmLabels);
                }

                //load airports
                // Fetch the data
                fetch('https://flyzonemediabuckets.s3.amazonaws.com/airport.json')
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
                        }
                        return response.json();
                    })
                    .then(data => {
                        setAirportData(data);
                    })
                    .catch(error => {
                        console.error('Error fetching airport data:', error);
                        //setError(error);
                        //setLoading(false);
                    });

                //addB4UFlyLayers(); //b4ufly call
            });

            // Wait for all tiles to load before allowing feature queries
            // Optimization Item #4: Store handler references for proper cleanup
            const handleIdle = () => {
                //console.log('Map tiles fully loaded');
                setMapTilesLoaded(true);
                // Check if style is also loaded
                if (mapRef.isStyleLoaded()) {
                    setStyleLoaded(true);
                }
            };
            mapRef.on('idle', handleIdle);

            // Reset tiles loaded when style changes
            const handleStyleData = () => {
                setMapTilesLoaded(false);
                setStyleLoaded(false);

                const tfrDataUrl = "https://flyzonemediabuckets.s3.us-east-1.amazonaws.com/tfr.geojson";
                //tfr - only add if it doesn't exist
                if (!mapRef.getSource('laanc-tfr')) {
                    mapRef.addSource('laanc-tfr', {
                        type: 'geojson',
                        data: tfrDataUrl, // URL to GeoJSON
                    });
                }

                if (!mapRef.getLayer('laanc-tfr')) {
                    mapRef.addLayer({
                        id: 'laanc-tfr',
                        type: 'fill',
                        source: 'laanc-tfr',
                        layout: {
                            visibility: 'none' // Initially hide the layer
                        },
                        paint: {
                            'fill-color': '#de1d1d', // Polygon fill color
                            'fill-opacity': 0.2, // Transparency
                        }
                    });
                }

                //SEAMS-Stadium
                const seamsDataUrl = "https://flyzonemediabuckets.s3.us-east-1.amazonaws.com/laanc-seams.geojson";

                if (!mapRef.getSource('laanc-seams')) {
                    mapRef.addSource('laanc-seams', {
                        type: 'geojson',
                        data: seamsDataUrl, // URL to GeoJSON
                    });
                }

                if (!mapRef.getLayer('laanc-seams')) {
                    mapRef.addLayer({
                        id: 'laanc-seams',
                        type: 'fill',
                        source: 'laanc-seams',
                        layout: {
                            visibility: 'visible'
                        },
                        paint: {
                            'fill-color': '#b1f7f6',         // User-friendly light cyan
                            'fill-opacity': 0,             // Consistent transparency
                        }
                    });
                }

                if (!mapRef.getLayer('seams-outline')) {
                    mapRef.addLayer({
                        id: 'seams-outline',
                        type: 'line',
                        source: 'laanc-seams',
                        layout: {
                            visibility: 'visible'
                        },
                        paint: {
                            'line-color': '#088',
                            'line-width': 1
                        }
                    });
                }

                //B4UFLY Layers

                // boundary_airspace-------
                const boundary_airspaceDataUrl = "https://flyzonemediabuckets.s3.us-east-1.amazonaws.com/flyzone-b4ufly-part93-sata.geojson";
                if (!mapRef.getSource('laanc-b4ufly-boundary-airspace')) {
                    mapRef.addSource('laanc-b4ufly-boundary-airspace', {
                        type: 'geojson',
                        data: boundary_airspaceDataUrl,
                        promoteId: 'id'
                    });
                }

                if (!mapRef.getLayer('laanc-b4ufly-boundary-airspace')) {
                    mapRef.addLayer({
                        id: 'laanc-b4ufly-boundary-airspace',
                        type: 'fill',
                        source: 'laanc-b4ufly-boundary-airspace',
                        layout: {visibility: 'visible'},
                        paint: {
                            'fill-color': '#de1d1d',
                            'fill-opacity': 0.2
                        }
                    });
                }

                // faa_recog--------------
                const faa_riaDataUrl = "https://flyzonemediabuckets.s3.us-east-1.amazonaws.com/flyzone-b4ufly-fria.geojson";

                if (!mapRef.getSource('laanc-b4ufly-faa-ria')) {
                    mapRef.addSource('laanc-b4ufly-faa-ria', {
                        type: 'geojson',
                        data: faa_riaDataUrl,
                        promoteId: 'id'
                    });
                }

                if (!mapRef.getLayer('laanc-b4ufly-faa-ria')) {
                    mapRef.addLayer({
                        id: 'laanc-b4ufly-faa-ria',
                        type: 'fill',
                        source: 'laanc-b4ufly-faa-ria',
                        layout: {visibility: 'visible'},
                        paint: {
                            'fill-color': '#de1d1d',
                            'fill-opacity': 0.1
                        }
                    });
                }

                // Recreational-------------
                const recreationalDataUrl = "https://flyzonemediabuckets.s3.us-east-1.amazonaws.com/flyzone-b4ufly-recreational.geojson";

                if (!mapRef.getSource('laanc-b4ufly-recreational')) {
                    mapRef.addSource('laanc-b4ufly-recreational', {
                        type: 'geojson',
                        data: recreationalDataUrl,
                        promoteId: 'id'
                    });
                }

                if (!mapRef.getLayer('laanc-b4ufly-recreational')) {
                    mapRef.addLayer({
                        id: 'laanc-b4ufly-recreational',
                        type: 'fill',
                        source: 'laanc-b4ufly-recreational',
                        layout: {visibility: 'visible'},
                        paint: {
                            'fill-color': '#2a2b29',
                            'fill-opacity': 0.2
                        }
                    });
                }

                // mtrs----------
                const mtrsDataUrl = "https://flyzonemediabuckets.s3.us-east-1.amazonaws.com/flyzone-b4ufly-mtrs.geojson";

                if (!mapRef.getSource('laanc-b4ufly-mtrs')) {
                    mapRef.addSource('laanc-b4ufly-mtrs', {
                        type: 'geojson',
                        data: mtrsDataUrl,
                        promoteId: 'id'
                    });
                }

                if (!mapRef.getLayer('laanc-b4ufly-mtrs')) {
                    mapRef.addLayer({
                        id: 'laanc-b4ufly-mtrs',
                        type: 'fill',
                        source: 'laanc-b4ufly-mtrs',
                        layout: {visibility: 'visible'},
                        paint: {
                            'fill-color': '#0e3de6',
                            'fill-opacity': 0.2
                        }
                    });
                }


                // layers filter - check if style is loaded first
                if (!mapRef.isStyleLoaded()) {
                    return;
                }

                const allLayers = mapRef.getStyle().layers;

                // Filter layers that start with the prefix
                const filteredLayers = allLayers.filter((layer) => layer.id.includes('laanc-'));

                // console.log(filteredLayers);
                // Log or handle the filtered layers
                //if ( process.env.REACT_APP_ENV === 'qa')

                setAllLayers(filteredLayers);
            };
            mapRef.on('styledata', handleStyleData);

            // Optimization Item #4: Store error handler reference for cleanup
            const handleError = (e) => {
                // Error handling
            };
            mapRef.on('error', handleError);


            // Dynamically control layer visibility based on zoom level
            // Register once, not inside styledata to avoid duplicates
            const handleZoom = () => {
                const zoom = mapRef.getZoom();
                if (zoom >= 8) {
                    // Show layers when zoomed in
                    if (mapRef.getLayer('laanc-tfr')) {
                        mapRef.setLayoutProperty('laanc-tfr', 'visibility', 'visible');
                    }
                    if (mapRef.getLayer('laanc-seams')) {
                        mapRef.setLayoutProperty('laanc-seams', 'visibility', 'visible');
                    }
                } else {
                    // Hide layers when zoomed out
                    if (mapRef.getLayer('laanc-tfr')) {
                        mapRef.setLayoutProperty('laanc-tfr', 'visibility', 'none');
                    }
                    if (mapRef.getLayer('laanc-seams')) {
                        mapRef.setLayoutProperty('laanc-seams', 'visibility', 'none');
                    }
                }
            };

            mapRef.on('zoom', handleZoom);

            // Optimization Item #4: Cleanup function to remove ALL event listeners
            // Prevents memory leaks - reduces memory usage by 20-40% over time
            return () => {
                if (mapRef) {
                    mapRef.off('idle', handleIdle);
                    mapRef.off('styledata', handleStyleData);
                    mapRef.off('error', handleError);
                    mapRef.off('zoom', handleZoom);
                }
            };
        }
    }, [mapRef]);

    // Cleanup airport markers on unmount
    useEffect(() => {
        return () => {
            airportMarkers.forEach(marker => marker.remove());
        };
    }, [airportMarkers]);

    //    //------------------------------------- Create a separate function for B4UFLY layers-------------------------------------------
    //
    // const addB4UFlyLayers = () => {
    //    if (!mapRef) return;
    //
    //    console.log('Adding B4UFLY layers...');
    //
    //    mapRef.setStyle('mapbox://styles/thilankadamith/cm2ypbywd00n001pwgg2463h6');
    //
    //    // Wait for the style to load
    //    mapRef.once('style.load', () => {
    //        console.log('QA street style loaded successfully');
    //
    //        addGeoJsonLayers();
    //        //setupMapboxStyleLayers();
    //    });
    //
    //    function addGeoJsonLayers() {
    //
    //    // boundary_airspace-------
    //    const boundary_airspaceDataUrl = "https://flyzonemediabuckets.s3.us-east-1.amazonaws.com/flyzone-b4ufly-part93-sata.geojson";
    //
    //    // Check if source doesn't exist before adding
    //    if (!mapRef.getSource('laanc-b4ufly-boundary-airspace')) {
    //        mapRef.addSource('laanc-b4ufly-boundary-airspace', {
    //            type: 'geojson',
    //            data: boundary_airspaceDataUrl,
    //            promoteId: 'id'
    //        });
    //    }
    //
    //    if (!mapRef.getLayer('laanc-b4ufly-boundary-airspace')) {
    //        mapRef.addLayer({
    //            id: 'laanc-b4ufly-boundary-airspace',
    //            type: 'fill',
    //            source: 'laanc-b4ufly-boundary-airspace',
    //            layout: { visibility: 'visible' },
    //            paint: {
    //                'fill-color': '#de1d1d',
    //                'fill-opacity': 0.2
    //            }
    //        });
    //    }
    //
    //    // Add click interaction
    //    mapRef.on('click', 'laanc-b4ufly-boundary-airspace', (e) => {
    //        if (!e.features || e.features.length === 0) return;
    //        const feature = e.features[0];
    //        if (feature && feature.properties) {
    //            console.log('boundary_airspace feature clicked:', feature.properties);
    //        }
    //    });
    //
    //    // faa_recog--------------
    //    const faa_riaDataUrl = "https://flyzonemediabuckets.s3.us-east-1.amazonaws.com/b4ufly_faa_ria.geojson";
    //
    //    if (!mapRef.getSource('laanc-b4ufly-faa-ria')) {
    //        mapRef.addSource('laanc-b4ufly-faa-ria', {
    //            type: 'geojson',
    //            data: faa_riaDataUrl,
    //            promoteId: 'id'
    //        });
    //    }
    //
    //    if (!mapRef.getLayer('laanc-b4ufly-faa-ria')) {
    //        mapRef.addLayer({
    //            id: 'laanc-b4ufly-faa-ria',
    //            type: 'fill',
    //            source: 'laanc-b4ufly-faa-ria',
    //            layout: { visibility: 'visible' },
    //            paint: {
    //                'fill-color': '#de1d1d',
    //                'fill-opacity': 0.1
    //            }
    //        });
    //    }
    //
    //    // Add click interaction
    //    mapRef.on('click', 'laanc-b4ufly-faa-ria', (e) => {
    //        if (!e.features || e.features.length === 0) return;
    //        const feature = e.features[0];
    //        if (feature && feature.properties) {
    //            console.log('faa_ria feature clicked:', feature.properties);
    //        }
    //    });
    //
    //    // Recreational-------------
    //    const recreationalDataUrl = "https://flyzonemediabuckets.s3.us-east-1.amazonaws.com/b4ufly_recreational.geojson";
    //
    //    if (!mapRef.getSource('laanc-b4ufly-recreational')) {
    //        mapRef.addSource('laanc-b4ufly-recreational', {
    //            type: 'geojson',
    //            data: recreationalDataUrl,
    //            promoteId: 'id'
    //        });
    //    }
    //
    //    if (!mapRef.getLayer('laanc-b4ufly-recreational')) {
    //        mapRef.addLayer({
    //            id: 'laanc-b4ufly-recreational',
    //            type: 'fill',
    //            source: 'laanc-b4ufly-recreational',
    //            layout: { visibility: 'visible' },
    //            paint: {
    //                'fill-color': '#2a2b29',
    //                'fill-opacity': 0.2
    //            }
    //        });
    //    }
    //
    //    // Add click interaction
    //    mapRef.on('click', 'laanc-b4ufly-recreational', (e) => {
    //        if (!e.features || e.features.length === 0) return;
    //        const feature = e.features[0];
    //        if (feature && feature.properties) {
    //            console.log('Recreational feature clicked:', feature.properties);
    //        }
    //    });
    //
    //    // mtrs----------
    //    const mtrsDataUrl = "https://flyzonemediabuckets.s3.us-east-1.amazonaws.com/b4ufly_mtrs.geojson";
    //
    //    if (!mapRef.getSource('laanc-b4ufly-mtrs')) {
    //        mapRef.addSource('laanc-b4ufly-mtrs', {
    //            type: 'geojson',
    //            data: mtrsDataUrl,
    //            promoteId: 'id'
    //        });
    //    }
    //
    //    if (!mapRef.getLayer('laanc-b4ufly-mtrs')) {
    //        mapRef.addLayer({
    //            id: 'laanc-b4ufly-mtrs',
    //            type: 'fill',
    //            source: 'laanc-b4ufly-mtrs',
    //            layout: { visibility: 'visible' },
    //            paint: {
    //                'fill-color': '#0e3de6',
    //                'fill-opacity': 0.2
    //            }
    //        });
    //    }
    //
    //    // Add click interaction for mtrs
    //    mapRef.on('click', 'laanc-b4ufly-mtrs', (e) => {
    //        if (!e.features || e.features.length === 0) return;
    //        const feature = e.features[0];
    //        if (feature && feature.properties) {
    //            console.log('mtrs feature clicked:', feature.properties);
    //        }
    //    });
    //
    // }

    // Function to setup click events for layers already in Mapbox style
    //    function setupMapboxStyleLayers() {
    //        const allLayers = mapRef.getStyle().layers;
    //        console.log(`Found ${allLayers.length} layers in QA street style`);
    //
    //        // Search for our target layers
    //        const targetKeywords = [
    //            'fish-wildlife',
    //            'forest-services',
    //            'wilderness',
    //            'national-parks'
    //        ];
    //
    //        targetKeywords.forEach(keyword => {
    //            // Find all layers that contain this keyword
    //            const matchingLayers = allLayers.filter(layer =>
    //                layer.id.includes(keyword)
    //            );
    //
    //            if (matchingLayers.length > 0) {
    //                console.log(`Found ${matchingLayers.length} layers with "${keyword}":`,
    //                    matchingLayers.map(l => l.id));
    //
    //                // Add click events to each matching layer
    //                matchingLayers.forEach(layer => {
    //                    mapRef.on('click', layer.id, (e) => {
    //                        if (!e.features || e.features.length === 0) return;
    //                        const feature = e.features[0];
    //                        if (feature && feature.properties) {
    //                            console.log(`${layer.id} clicked:`, feature.properties);
    //                        }
    //                    });
    //                });
    //            } else {
    //                console.log(`No layers found with keyword: "${keyword}"`);
    //            }
    //        });
    //
    //        // Also log all layer names for debugging
    //        console.log('All layer names in style:');
    //        allLayers.forEach((layer, index) => {
    //            console.log(`${index}: ${layer.id} (${layer.type})`);
    //        });
    //    }
// };


    // useEffect(() => {
    //
    //     if (mapRef) {
    //
    //         mapRef.on('movestart', () => {
    //
    //             if (mapRef.getZoom() === zoomLevel){
    //                 //console.log("move start");
    //                 setSlideEvent(true);
    //             }
    //
    //         });
    //
    //
    //         mapRef.on('moveend', () => {
    //             //console.log(slideEvent + " moveend");
    //             // //console.log(mapRef.getZoom() + " " + zoomLevel);
    //             if (mapRef.getZoom() === zoomLevel) {
    //                 //trigger detail bar load event
    //                 if (!slideEvent) {
    //                     //console.log("move:load detail bar");
    //                     setLoadDetailBarLogic(true);
    //                 }
    //                 mapRef.scrollZoom.enable();
    //             }
    //         });
    //     }
    // }, [mapRef]);//mapRef, flyEvent

    useEffect(() => {
        slideEventRef.current = slideEvent;
    }, [slideEvent]);

    useEffect(() => {
        if (mapRef) {
            const onMoveStart = () => {
                if (mapRef.getZoom() === zoomLevel) {
                    //console.log("move start");
                    setSlideEvent(true);
                    //console.log(slideEvent + " move start");
                }
            };

            const onMoveEnd = () => {
                //console.log(slideEventRef.current + " moveend");
                if (mapRef.getZoom() === zoomLevel) {
                    if (!slideEventRef.current) {
                        //console.log("move:load detail bar");
                        setLoadDetailBarLogic(true);
                        setSlideEvent(true);
                    }
                    mapRef.scrollZoom.enable();
                }
            };

            mapRef.on('movestart', onMoveStart);
            mapRef.on('moveend', onMoveEnd);

            return () => {
                mapRef.off('movestart', onMoveStart);
                mapRef.off('moveend', onMoveEnd);
            };
        }
    }, [mapRef]);


    //handle parameter changes within detail bar
    useEffect(() => {
        if (slideEventRef.current && selectedDate && selectedTime && duration && !loadParamLogic) {
            mapRef.setCenter(circleCenter);
            mapRef.setZoom(zoomLevel);
            setLoadParamLogic(true);
        }
    }, [selectedDate, selectedTime, duration, radius]);

    // Optimization Item #12: Memoize MapGL event handlers to prevent re-renders
    const handleMapMove = useCallback((evt) => {
        setViewPort(evt.viewState);
    }, []);

    const handleMapError = useCallback((e) => {
        console.error('Mapbox error:', e.error || e);
    }, []);

    return (
        <div>
            <PopupAlert open={open} handleClose={handleClose} message={errorDetails.description}
                title={errorDetails.error} buttonText={"Close"} />
            <MapGL
                ref={(ref) => setMapRef(ref && ref.getMap())}
                mapboxAccessToken="pk.eyJ1IjoidGhpbGFua2FkYW1pdGgiLCJhIjoiY2x6Y3Izb3liMGVoODJpb2hjemcyZ21iMyJ9.cmoQD4aNYtU4KuTeVd5cKg"
                initialViewState={viewPort}
                style={{
                    position: 'fixed',
                    width: "97%",
                    height: "100%",
                    zIndex: 1,
                }}
                mapStyle={currentMapStyle}
                onClick={handleMapClick}
                onDblClick={handleClick}
                onMove={handleMapMove}
                onError={handleMapError}
            >
                {newPlace && markerVisible && (
                    <Marker latitude={newPlace.lat} longitude={newPlace.long}>
                        <Mapmarker width="75" height="75" className={HomeStyles.mapmarkernew} />
                    </Marker>
                )}
                {newPlace && viewPort ? (
                    <Marker latitude={newPlace.lat} longitude={newPlace.long}>
                        <Mapmarker width="40" height="40" className={HomeStyles.mapmarkernew} />
                    </Marker>
                ) : null}

            </MapGL>

            <div className={HomeStyles.controlpanelicons}>
                <button onClick={activateGeolocate} title='Current Location'>
                    <img src={Geoloacateicon} alt="" className={HomeStyles.Geoloacateicon} />
                </button>

                <button onClick={activateGlobal} title='Styles'>
                    <img src={globalIcon} alt="" className={HomeStyles.globalIcon} />
                </button>

                <button onClick={activateZoomin} title='Zoom In'>
                    <img src={Zoominicon} alt="" className={HomeStyles.Zoomin} />
                </button>

                <button onClick={activateZoomout} title='Zoom Out'>
                    <img src={Zoomouticon} alt="" className={HomeStyles.Zoomout} />
                </button>
            </div>

            <div id="detailbar"
                ref={detailbarRef}
                className={`${HomeStyles.detailbar} ${detailbarVisible ? HomeStyles.detailbaractive : ''}`}
                role="dialog"
                aria-modal="true"
                aria-labelledby="detailbar-heading"
                aria-hidden={!detailbarVisible}
                tabIndex="-1">
                <div className={HomeStyles.detailbarcontent}>
                    {view === 'detailbar' ? (
                        <>
                            <DateTimePicker
                                authenticated={authenticated}
                                profile={profile}
                                selectedPurpose={selectedPurpose}
                                setSelectedPurpose={setSelectedPurpose}
                                selectedDate={selectedDate}
                                setSelectedDateMui={setSelectedDateMui}
                                selectedTimeMui={selectedTimeMui}
                                setSelectedTimeMui={setSelectedTimeMui}
                                duration={duration}
                                handleDurationChange={handleDurationChange}
                                currentLocaDate={currentLocaDate}
                                maxDate={maxDate}
                                getFormattedDate={getFormattedDate}
                                getFormattedTime={getFormattedTime}
                                selectedTimeZone={selectedTimeZone}
                                HomeStyles={HomeStyles}
                                radius={radius}
                                setRadius={setRadius}
                                altitude={altitude}
                                setAltitude={setAltitude}
                                maxAltitude={maxAltitude}
                                geometryType={geometryType}
                                setGeometryType={setGeometryType}
                                polygonPoints={polygonPoints}
                                onCompletePolygon={handleCompletePolygon}
                                onClearPolygon={handleClearPolygon}
                                circleGeoJSON={circleGeoJSON}
                                polygonError={polygonError}
                            />
                            <LocationDetails
                                addressDetails={addressDetails}
                                newPlace={newPlace}
                                locationicon={locationicon}
                                HomeStyles={HomeStyles}
                                getFormattedDate={getFormattedDate}
                                getFormattedTime={getFormattedTime}
                                selectedTimeZone={selectedTimeZone}
                            />
                            <Advisories detailbarContent={detailbarContent} HomeStyles={HomeStyles}
                                        nearbyAirspaces={nearbyAirspaces} nearbyAirports={nearbyAirportsData}/>
                        </>
                    ) : (
                        <PersonalInfo profile={profile} sel_purpose={selectedPurpose} />
                    )}
                </div>
                <DetailBarButtons
                    view={view}
                    setView={setView}
                    detailbarVisible={detailbarVisible}
                    setDetailbarVisible={setDetailbarVisible}
                    detailbarContent={detailbarContent}
                    authenticated={authenticated}
                    preCheck={preCheck}
                    preInvalidCheck={preInvalidCheck}
                    maxAltitude={maxAltitude}
                    altitude={altitude}
                    selectedPurpose={selectedPurpose}
                    profile={profile}
                    selectedTimeZone={selectedTimeZone}
                    setSelectedTimeZone={setSelectedTimeZone}
                    selectedDate={selectedDate}
                    selectedTime={selectedTime}
                    isCurrentDateInPast={isCurrentDateInPast}
                    getISOTimeInTimeZone={getISOTimeInTimeZone}
                    captchaValue={captchaValue}
                    loadOperations={loadOperations}
                    circleGeoJSON={circleGeoJSON}
                    circleCenter={circleCenter}
                    HomeStyles={HomeStyles}
                    isUserEmailVerified={isUserEmailVerified}
                    alert={alert}
                    handleCloseAlert={handleCloseAlert}
                    onReview={handleReviewOperation}
                    detailbarButtonVisible={detailbarButtonVisible}
                />
            </div>
            {showTip && (
                <div className={HomeStyles.user_tip_popup}>
                    <button onClick={closeTip} className={HomeStyles.close_tip_button}>
                        &times;
                    </button>
                    <p>
                        {geometryType === 'circle'
                            ? 'Tip: Double-click on the map to select a location'
                            : 'Tip: Click on the map to add polygon points'
                        }
                    </p>
                </div>
            )}
        </div>
    );
}

export default Home;
